
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire62dd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire62dd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


const $cdbf8f036183e294$export$4051a07651545597 = {
    "nodes": [
        {
            "id": "Addiction friction",
            "tldr": [
                "Dopamine is often described as a \u201Cfeel-good\u201D chemical, but its deeper role is regulation \u2014 not pleasure. It governs motivation, learning, attachment, and how the brain adapts to its environment. In conditions of scarcity, this system evolved to keep humans alive. In conditions of abundance, the same system becomes stressed. What emerges is not excess pleasure, but instability: craving, numbness, and loss of agency."
            ],
            "connections": [
                "Sweet and salty sugar",
                "Unmanned man",
                "Out of focus",
                "Brain health 101",
                "Brainiac strategies for the brain",
                "Mind at volume",
                "Socialized wellness"
            ],
            "url": "https://wellawarecare.substack.com/p/addiction-friction"
        },
        {
            "id": "Alcohol & DNA",
            "tldr": [
                "Alcohol alters DNA methylation, disrupting gene expression and elevating cancer risks, especially breast cancer. ",
                "Fetal alcohol exposure causes severe, irreversible developmental damage. ",
                "Chronic drinking disturbs hormonal balance, converting testosterone into estrogen, increasing fat storage, and boosting cancer risks. ",
                "Low-to-moderate alcohol intake disrupts the gut-liver-brain axis, triggering systemic inflammation and compounding health issues. ",
                "Alcohol\u2019s reach extends into our biology, damaging DNA, gut health, and neural circuits while altering hormonal balance and immune function."
            ],
            "connections": [
                "Level up your gut!",
                "Non-food foods",
                "The genetic disconnect",
                "Prevent that cancer",
                "Fermented food benefits",
                "Supplementation is not expensive urine",
                "Hack your fuel",
                "Hangovers",
                "When alcohol hits the cells",
                "Blackouts"
            ],
            "url": "https://wellawarecare.substack.com/p/alcohol-and-dna"
        },
        {
            "id": "Be better than the conventional normal",
            "tldr": [
                "Standard blood test ranges focus on \u201Cnormal,\u201D but aiming for optimal levels leads to better health outcomes. ",
                "Vitamin D, even if within a \u201Cnormal\u201D range, often needs to be optimized for bone, muscle, immune, and cognitive health. ",
                "Fasting blood glucose levels, though not classified as diabetic, can still signal risks if they exceed optimal ranges. ",
                "Potassium, hydration, and inflammation markers like albumin offer deeper insights into overall health. ",
                "Assessing sleep quality and environmental factors is essential for both immediate well-being and long-term health."
            ],
            "connections": [
                "Explosive & toxic chemicals in food",
                "Power up with potassium",
                "High performance sleeping",
                "Zinc it up"
            ],
            "url": "https://wellawarecare.substack.com/p/be-better-than-the-conventional-normal"
        },
        {
            "id": "Belly fat!",
            "tldr": [
                "Excess sugar and hormones like cortisol and estrogen mimickers can cause belly fat. Monitoring blood sugar is more effective than calorie counting. ",
                "Avoid diet foods with artificial ingredients; opt for sparkling water, mineral water, or tea. ",
                "Stay active to manage stress and eat plenty of vegetables for gut health. Get enough deep sleep to regulate hormones and prevent weight gain."
            ],
            "connections": [
                "Bread!",
                "One third of your youth",
                "High performance sleeping",
                "Less (eating) is more (healthy)",
                "Damn hard without vitamin D",
                "No sweet dreams with sweets"
            ],
            "url": "https://wellawarecare.substack.com/p/care-13-belly-fat"
        },
        {
            "id": "Blackouts",
            "tldr": [
                "Blackouts occur when memory formation stops, leaving people active but unable to recall events. ",
                "Some drinkers feel sedated, while others remain energized\u2014this latter group is more prone to habitual drinking and blackouts. ",
                "Alcohol alters stress pathways, increasing cortisol and baseline anxiety levels over time. ",
                "Memory blackouts aren\u2019t the same as passing out; they involve functioning without recording memories."
            ],
            "connections": [
                "Brain health 101",
                "When alcohol hits the cells",
                "Alcohol & DNA"
            ],
            "url": "https://wellawarecare.substack.com/p/blackouts"
        },
        {
            "id": "Bonds, alpha females & botox",
            "tldr": [
                "Eye contact, especially right-eye-to-left-eye, is key for emotional bonding. ",
                "Women who spend time together often sync their cycles, influenced by the alpha female. ",
                "Behaviors and attitudes, like divorce or weight gain, can spread through social groups. ",
                "Good health, shown in appearance and energy, often leads to better social and romantic interaction"
            ],
            "connections": [
                "Nasties in beauty"
            ],
            "url": "https://wellawarecare.substack.com/p/care-15-bonds-alpha-females-and-botox"
        },
        {
            "id": "Brain health 101",
            "tldr": [
                "Brain health is foundational to mental health; daily habits like nutrition, sleep, and avoiding toxins are critical. ",
                "Poor lifestyle choices\u2014like neglecting oral health, consuming harmful substances, or not engaging in lifelong learning\u2014can negatively impact brain function. ",
                "Prioritizing Omega-3s, Vitamin D, and regular hormone checks supports optimal brain function and reduces dementia risk. ",
                "Addressing emotional and spiritual well-being through self-reflection, purpose, and relationships enhances overall brain health."
            ],
            "connections": [
                "Effects of mouth's proximity to the brain",
                "Welcome the suck",
                "Non-food foods",
                "High performance sleeping",
                "Power up with potassium",
                "Preventing Alzheimer\u2019s with lifestyle choices",
                "The healthy hungry age better",
                "Zinc it up",
                "Reorder mental disorder",
                "Sweet and salty sugar",
                "Detox with sleep"
            ],
            "url": "https://wellawarecare.substack.com/p/brain-health-101"
        },
        {
            "id": "Brainiac strategies for the brain",
            "tldr": [
                "Poor diet, stress, and lack of sleep shrink the hippocampus, impairing memory and learning. ",
                "Obesity and inactivity harm brain health, while exercise and lean muscle mass protect against aging effects. ",
                "High sugar intake accelerates brain aging, damages memory, and disrupts insulin sensitivity. ",
                "Mindfulness, strength training, and managing chronic conditions promote brain and metabolic health. ",
                "Lifestyle choices, including a healthy diet and regular exercise, significantly impact cognitive vitality and resilience."
            ],
            "connections": [
                "Non-food foods",
                "The sugar consequences of salt",
                "Take 11 minutes a day to postpone death",
                "Sweet and salty sugar",
                "Insulin's hard problem",
                "Hold on to your strength"
            ],
            "url": "https://wellawarecare.substack.com/p/brainiac-strategies-for-the-brain"
        },
        {
            "id": "Bread!",
            "tldr": [
                "Eliminating processed grains for 14 days stabilizes blood sugar and reduces inflammation. ",
                "Healthy grains, like sourdough, enhance mood, digestion, and hunger management. ",
                "Avoiding bad grains repairs the gut lining, decreases joint pain, and improves sleep quality. ",
                "Learn how to distinguish between healthy and unhealthy grains to optimize health benefits."
            ],
            "connections": [
                "The real spice, girl!",
                "Belly fat!",
                "How does fasting affect hormones?",
                "How do you like them apples?",
                "High performance sleeping"
            ],
            "url": "https://wellawarecare.substack.com/p/bread"
        },
        {
            "id": "Can't lose weight?",
            "tldr": [
                "Women\u2019s bodies prioritize safety over weight loss due to evolutionary programming, making stress reduction essential for sustainable health changes. ",
                "Hormones need 24 key nutrients to function. Diet diversity and real food are critical for meeting these requirements. ",
                "Gut and liver health are foundational for hormone metabolism and detoxification, reducing fat storage and improving overall health. ",
                "Menstrual cycles and life stages (perimenopause, menopause) demand tailored nutrition and fasting strategies. ",
                "Toxic exposure disrupts hormonal balance, affecting weight, fertility, and overall health."
            ],
            "connections": [
                "Functional medicine functioning",
                "The real spice, girl!",
                "Belly fat!",
                "Level up your gut!",
                "Fruit juice to fatty liver",
                "Faster weight loss on slow thyroid",
                "Nasties in beauty",
                "Hack your fuel",
                "Pick not Ozempic",
                "When to eat?",
                "Functional medicine functioning"
            ],
            "url": "https://wellawarecare.substack.com/p/cant-lose-weight"
        },
        {
            "id": "Comfy crash",
            "tldr": [
                "The average person consumes 12\u201313 hours of digital media per day\u2014more screen than sleep. ",
                "Small daily discomforts\u2014like carrying groceries or climbing stairs\u2014are disappearing, and so is resilience. ",
                "Loneliness increases risk of early death by 26%\u2014and the epidemic is growing alongside urban density and noise. ",
                "Modern abundance hijacks ancient survival drives, leading to chronic diseases, addiction, and burnout. ",
                "Fighting back doesn\u2019t require extreme fitness\u2014it starts with tiny daily discomfort wins."
            ],
            "connections": [
                "Crave brain rave",
                "Hack your fuel",
                "Power up with potassium",
                "Preventing Alzheimer\u2019s with lifestyle choices",
                "Socialized wellness"
            ],
            "url": "https://wellawarecare.substack.com/p/comfy-crash"
        },
        {
            "id": "Complexities of depression",
            "tldr": [
                "The chemical imbalance theory oversimplifies depression's causes and treatment. ",
                "Antidepressants have limited efficacy and can carry significant risks, such as suicidal thoughts in younger individuals. ",
                "Depression intertwines with physical health factors like stress, sleep disturbances, and nutrition. ",
                "A holistic approach, including lifestyle changes, offers a more comprehensive way to manage depression. ",
                "Nutritional deficiencies in vitamin D, B12, magnesium, and Omega-3 DHA often contribute to depressive symptoms."
            ],
            "connections": [
                "Brain health 101",
                "Non-food foods",
                "Damn hard without vitamin D",
                "Detox with sleep",
                "Reorder mental disorder",
                "Health we inherit"
            ],
            "url": "https://wellawarecare.substack.com/p/complexities-of-depression"
        },
        {
            "id": "Crave brain rave",
            "tldr": [
                "Cravings are real chemical signals, not mental weakness. They reflect your brain and body seeking balance. ",
                "Triggers include stress, nutrient deficiencies, blood sugar crashes, and social pressure. ",
                "Ultra-processed foods (UPFs) exploit biological mechanisms, creating misleading cravings and disrupting hunger regulation. ",
                "Post-ingestive feedback\u2014how your body \u201Cremembers\u201D nutrients\u2014is hijacked by flavor-engineered foods. ",
                "To reduce cravings: restore balance with real food, sufficient protein, deep rest, and stable social cues."
            ],
            "connections": [
                "Your energy source",
                "Non-food foods",
                "Insulin's hard problem",
                "Reorder mental disorder",
                "Starve that cancer",
                "Sweet and salty sugar",
                "Explosive & toxic chemicals in food",
                "Preventing Alzheimer\u2019s with lifestyle choices"
            ],
            "url": "https://wellawarecare.substack.com/p/crave-brain-rave"
        },
        {
            "id": "Crystal clear pain",
            "tldr": [
                "Oxalates are naturally occurring compounds found in many plant foods. In small amounts, the body can handle them. But when intake, absorption, or clearance is mismatched, oxalates bind minerals, form crystals, and interfere with cellular energy systems. Over time, this load shows up far beyond the kidneys\u2014affecting pain, circulation, tissue repair, and mitochondrial function."
            ],
            "connections": [
                "Forged in iron",
                "Joint pain",
                "How does fasting affect hormones?",
                "Level up your gut!"
            ],
            "url": "https://wellawarecare.substack.com/p/crystal-clear-pain"
        },
        {
            "id": "Damn hard without vitamin D",
            "tldr": [
                "Vitamin D is vital for immunity, mood regulation, skin health, and cardiovascular function\u2014not just bones. ",
                "Deficiency can lead to asthma, eczema, depression, irregular cycles, and erectile dysfunction. ",
                "Pair vitamin D with vitamin K2 to prevent calcium buildup and enhance bone and heart health. ",
                "Autoimmune and inflammatory conditions benefit from higher vitamin D doses alongside keto or intermittent fasting. ",
                "Vitamin D may be the missing link for those struggling with chronic fatigue or respiratory issues."
            ],
            "connections": [
                "Be better than the conventional normal",
                "Functional medicine functioning",
                "Explosive & toxic chemicals in food",
                "Vitamin D Deficiency",
                "Hold on to your strength"
            ],
            "url": "https://wellawarecare.substack.com/p/damn-hard-without-vitamin-d"
        },
        {
            "id": "Detox with sleep",
            "tldr": [
                "Quality sleep clears toxins, boosts immunity, balances hormones, and strengthens memory. ",
                "Your chronotype (morning, evening, or intermediate) influences sleep patterns; aligning with it can optimize productivity. ",
                "Naps improve performance, cardiovascular health, and emotional well-being when timed correctly. ",
                "Regular sleep reduces the risk of Alzheimer\u2019s, obesity, and diabetes while enhancing resilience and mental clarity."
            ],
            "connections": [
                "Be better than the conventional normal",
                "High performance sleeping",
                "Preventing Alzheimer\u2019s with lifestyle choices",
                "Brain health 101"
            ],
            "url": "https://wellawarecare.substack.com/p/detox-with-sleep"
        },
        {
            "id": "Don't de-health while deodorizing",
            "tldr": [
                "Conventional deodorants, especially antiperspirants with aluminum salts, pose health risks by blocking sweat ducts and increasing toxic absorption. ",
                "Aluminum salts in antiperspirants are linked to higher breast cancer risk, particularly when used before age 30. ",
                "Aerosol deodorants carry additional inhalation risks, and petroleum byproducts in some deodorants can contain carcinogenic compounds. ",
                "Natural alternatives like coconut oil, baking soda, and essential oils provide safer options. ",
                "An armpit detox with clay can help remove residual aluminum salts and reset natural body odor."
            ],
            "connections": [
                "Femme fatale fragrance",
                "Ketogenic diet and cancer",
                "How does fasting affect hormones?",
                "Nasties in beauty",
                "The genetic disconnect",
                "Starve that cancer"
            ],
            "url": "https://wellawarecare.substack.com/p/dont-de-health-while-deodorizing"
        },
        {
            "id": "Eating electronics",
            "tldr": [
                "Environmental toxins like BPA and phthalates act as biological mimics that disrupt hormonal signaling. Found in common items like thermal receipts and plastic food containers, these chemicals dock into hormone receptors and trick the body into downregulating natural production. Managing this load requires identifying the mechanical intersection of heat and plastic to prevent systemic chemical leaching."
            ],
            "connections": [
                "Nasties in beauty",
                "The genetic disconnect",
                "How does fasting affect hormones?",
                "Is organic food worth it?"
            ],
            "url": "https://wellawarecare.substack.com/p/eating-electronics"
        },
        {
            "id": "Effects of mouth's proximity to the brain",
            "tldr": [
                "Oral bacteria, like P. gingivalis, can cross the blood-brain barrier and are linked to Alzheimer\u2019s. ",
                "Mouth breathing, poor diet, and inadequate oral hygiene practices rank as top causes of gum disease. ",
                "Flossing, tongue scraping, and gum massage play crucial roles in maintaining oral health and preventing systemic diseases. ",
                "Certain mouthwashes can harm the oral microbiome; gentle brushing and eco-friendly tools are recommended."
            ],
            "connections": [
                "Non-food foods",
                "Preventing Alzheimer\u2019s with lifestyle choices",
                "Brain health 101",
                "Less (eating) is more (healthy)",
                "Nasties in beauty",
                "Hold on to your strength",
                "Detox with sleep"
            ],
            "url": "https://wellawarecare.substack.com/p/effects-of-mouths-proximity-to-the"
        },
        {
            "id": "Explosive & toxic chemicals in food",
            "tldr": [
                "High deuterium in processed foods accelerates aging; low-deuterium diets are healthier. ",
                "Glyphosate disrupts liver function and microbiomes, and harms wildlife. ",
                "Don't take calcium with vitamin D to avoid calcium buildup. Vitamin K2 helps direct calcium to bones. ",
                "Sunlight boosts melatonin and skin protection. Deuterium, glyphosate, and vitamin D deficiency affect telomere health."
            ],
            "connections": [
                "Bread!",
                "Is organic food worth it?",
                "Level up your gut!",
                "Femme fatale fragrance",
                "Functional medicine functioning",
                "Your energy source",
                "Damn hard without vitamin D"
            ],
            "url": "https://wellawarecare.substack.com/p/care-14-explosive-and-toxic-chemicals"
        },
        {
            "id": "Faster weight loss on slow thyroid",
            "tldr": [
                "Fasting, especially intermittent fasting and OMAD (One Meal A Day), boosts metabolism, enhances cognitive function, and promotes gut health through autophagy. ",
                "People with slow thyroid or thyroid removal can benefit from transitioning fuel sources from glucose to ketones, aiding in weight loss and improving metabolic efficiency. ",
                "Prebiotic fiber and fasting hacks ease hunger, promote satiety, and support gut health during fasting. ",
                "A gradual progression from three meals a day to OMAD helps stabilize insulin levels and supports fat burning, especially in those with thyroid issues."
            ],
            "connections": [
                "How does fasting affect hormones?",
                "Functional medicine functioning",
                "How do you like them apples?",
                "Level up your gut!",
                "Less (eating) is more (healthy)"
            ],
            "url": "https://wellawarecare.substack.com/p/faster-weight-loss-on-slow-thyroid"
        },
        {
            "id": "Femme fatale fragrance",
            "tldr": [
                "Phthalates, used as fragrance fixatives in many feminine care products, are estrogenic compounds that disrupt hormonal balance and pose serious health risks. ",
                "Feminine care products like scented tampons, pads, and period underwear can deliver harmful chemicals directly to sensitive areas, bypassing the body\u2019s natural detox pathways. ",
                "Organic cotton pads, medical-grade silicone menstrual cups, and PFAS-tested period underwear offer safer alternatives. ",
                "The highly absorptive nature of the vaginal area makes it critical to avoid products containing harmful chemicals, including plasticizers and PFAS."
            ],
            "connections": [
                "Don't de-health while deodorizing",
                "Nasties in beauty",
                "The genetic disconnect",
                "Master of detox"
            ],
            "url": "https://wellawarecare.substack.com/p/femme-fatale-fragrance"
        },
        {
            "id": "Fermented food benefits",
            "tldr": [
                "A diverse gut microbiome supports immunity, hormone balance, and mental health. ",
                "Fermented foods like sauerkraut, kefir, and Greek yogurt improve microbial diversity and reduce inflammation. ",
                "Fiber\u2019s effects on gut health vary, but low-sugar fermented foods offer consistent benefits. ",
                "Supplements with probiotics, prebiotics, and digestive enzymes are essential for those lacking dietary support. ",
                "Moderation is crucial\u2014excessive supplement use can cause issues like brain fog."
            ],
            "connections": [
                "The real spice, girl!",
                "Level up your gut!",
                "Explosive & toxic chemicals in food",
                "How do you like them apples?",
                "Non-food foods",
                "Supplementation is not expensive urine",
                "Hack your fuel"
            ],
            "url": "https://wellawarecare.substack.com/p/fermented-food-benefits"
        },
        {
            "id": "Filter with liver",
            "tldr": [
                "The liver is designed to absorb stress quietly. It stores fat, neutralizes toxins, processes hormones, manages bile, filters microbial byproducts, and regenerates without complaint. Because of this resilience, dysfunction rarely appears as pain or obvious disease. Instead, it emerges indirectly\u2014through metabolic markers, hormonal shifts, gut symptoms, brain changes, and sensitivity to substances that once caused no issue. Seeing liver health requires tracing how these systems stay connected."
            ],
            "connections": [
                "Can't lose weight?",
                "When alcohol hits the cells",
                "Level up your gut!",
                "Inside job",
                "Rot is in the air",
                "Fruit juice to fatty liver",
                "One third of your youth",
                "The sugar consequences of salt",
                "When to eat?"
            ],
            "url": "https://wellawarecare.substack.com/p/filter-with-liver"
        },
        {
            "id": "Focus stacking",
            "tldr": [
                'Most people use caffeine as a blunt instrument to override fatigue, often resulting in "scattered brain" and energy crashes. The synergy between caffeine and L-Theanine\u2014a molecule used by monks for centuries\u2014represents a shift from raw stimulation to controlled attention. By regulating the nervous system\'s electrical baseline, this stack allows for high-output work without the physiological tax of a "fight or flight" response.'
            ],
            "connections": [
                "Filter with liver",
                "Level up your gut!",
                "Super sea food",
                "No sweet dreams with sweets"
            ],
            "url": "https://wellawarecare.substack.com/p/focus-stacking"
        },
        {
            "id": "Forged in iron",
            "tldr": [
                "Mineral balance is key to longevity\u2014deficiencies or overloads disrupt enzymatic function, protein folding, and overall health. ",
                "Iron is a double-edged sword\u2014critical for survival but dangerous in excess, leading to oxidative stress, inflammation, and chronic disease. ",
                "Zinc and copper must be balanced\u2014too much zinc can deplete copper, leading to iron mismanagement and metabolic dysfunction. ",
                "Ferritin levels correlate with longevity\u2014high levels accelerate aging, while moderate levels promote optimal health. ",
                "Vitamin A plays a role in iron and copper transport, making bioavailable animal-based sources crucial for absorption."
            ],
            "connections": [
                "Zinc it up"
            ],
            "url": "https://wellawarecare.substack.com/p/forged-in-iron"
        },
        {
            "id": "Fruit juice to fatty liver",
            "tldr": [
                "Fruit juice, despite being perceived as healthy, can cause fatty liver due to its high fructose content. ",
                "Fructose is metabolized by the liver and can lead to metabolic syndrome, obesity, and non-alcoholic fatty liver disease (NAFLD). ",
                "The lack of fiber in fruit juice accelerates fructose absorption, increasing health risks even without weight gain. ",
                "Smoothies with fruit juices can spike blood sugar levels, sometimes higher than sodas."
            ],
            "connections": [
                "The sugar consequences of salt",
                "One third of your youth",
                "Is organic food worth it?",
                "Less (eating) is more (healthy)",
                "When to eat?",
                "Starve that cancer",
                "Insulin's hard problem",
                "Can't lose weight?"
            ],
            "url": "https://wellawarecare.substack.com/p/care-16-fruit-juice-to-fatty-liver"
        },
        {
            "id": "Full of full fat",
            "tldr": [
                "Visceral fat is not just stored energy; it is an active, inflammatory organ. Unlike subcutaneous fat (the kind you can pinch), visceral fat wraps around internal organs and secretes cytokines that trigger systemic inflammation. This creates a biological feedback loop where chronic inflammation impairs insulin signaling, leading to more fat storage and a higher baseline of systemic stress."
            ],
            "connections": [
                "Alcohol & DNA",
                "Belly fat!",
                "Can't lose weight?",
                "Faster weight loss on slow thyroid",
                "Filter with liver",
                "Hack your fuel",
                "How do you like them apples?",
                "Is organic food worth it?",
                "The sugar consequences of salt",
                "When to eat?"
            ],
            "url": "https://wellawarecare.substack.com/p/full-of-full-fat"
        },
        {
            "id": "Functional medicine functioning",
            "tldr": [
                "Autoimmune diseases are linked to immune dysfunction, inflammation, gut issues, and stress. ",
                "Functional medicine treats root causes, considering allergens, microbes, toxins, stress, and diet. ",
                "To reverse autoimmune diseases: eliminate mold, eat whole foods, test for infections, address gluten sensitivity, and heal the gut. ",
                "Vitamin D is essential for managing autoimmune conditions, hormone balance in women, and testosterone and bone health in men."
            ],
            "connections": [
                "Your energy source"
            ],
            "url": "https://wellawarecare.substack.com/p/care-11-functional-medicine-functioning"
        },
        {
            "id": "Get muscle mass.ive",
            "tldr": [
                "Muscle isn\u2019t a passive calorie-burner at rest\u2014its real power is in glucose control, fat burning, and hormonal signaling. ",
                "True muscle health = strong function, mitochondrial density, low fat infiltration\u2014not just size. ",
                "Peak muscle mass in your 20s\u201330s sets the foundation for resilience and independence later. ",
                "Sarcopenia (age-related muscle loss) predicts frailty, cognitive decline, and early death. ",
                "Resistance training + protein-rich meals are your best investments for metabolic health, brain health, and long life."
            ],
            "connections": [
                "Meat (head) and iron (maiden)",
                "Hack your fuel",
                "Hold on to your strength",
                "Stress on purpose",
                "Be better than the conventional normal",
                "Power up with potassium",
                "Your energy source"
            ],
            "url": "https://wellawarecare.substack.com/p/get-muscle-mass.ive"
        },
        {
            "id": "Grit, Glucose & Grind",
            "tldr": [
                "Tenacity and willpower are not fixed traits \u2014 they are physiological capacities that can be strengthened. ",
                "The anterior mid-cingulate cortex (aMCC) serves as the central hub of persistence and goal-directed action. ",
                "Willpower is shaped more by belief systems and neural engagement than by glucose availability. ",
                "The autonomic nervous system provides the energetic foundation for sustained effort. ",
                "Purposeful discomfort, repetitive action, and open-ended practices enhance willpower over time."
            ],
            "connections": [
                "Hack your fuel",
                "Detox with sleep",
                "Get muscle mass.ive",
                "Stress on purpose"
            ],
            "url": "https://wellawarecare.substack.com/p/grit-glucose-and-grind"
        },
        {
            "id": "Hack your fuel",
            "tldr": [
                "Leptin is your fat-burning hormone, but resistance to it blocks weight loss. Fasting, metabolic switching, and protein cycling restore leptin sensitivity. ",
                "BDNF, a brain-enhancing protein, suppresses appetite, regulates blood sugar, and improves cognitive health. ",
                "Bone broth aids fasting by healing the gut, reducing hunger, and supporting metabolism with glycine, collagen, and electrolytes. ",
                "Protein cycling paired with fasting maximizes fat-burning and metabolic flexibility. ",
                "17-hour fasts with strategic nutrition stimulate autophagy, muscle growth, and insulin sensitivity for optimal weight loss."
            ],
            "connections": [
                "Your energy source",
                "Power up with potassium",
                "The healthy hungry age better",
                "Less (eating) is more (healthy)",
                "Stress on purpose",
                "When to eat?"
            ],
            "url": "https://wellawarecare.substack.com/p/hack-your-fuel"
        },
        {
            "id": "Hangovers",
            "tldr": [
                "Hangovers disrupt your brain, gut, and body, causing headaches, nausea, fatigue, and anxiety. ",
                "Alcohol interrupts sleep quality, microbiota balance, and electrolytes, worsening next-day symptoms. ",
                "Congeners in drinks like red wine and brandy intensify hangovers by impacting the gut microbiome. ",
                "Hydration, gut support, and electrolyte replenishment help mitigate hangovers, but the best prevention is moderation. ",
                "Cold exposure may alleviate symptoms but should be used cautiously."
            ],
            "connections": [
                "Power up with potassium",
                "Level up your gut!",
                "Supplementation is not expensive urine",
                "Alcohol & DNA",
                "Hack your fuel",
                "Fermented food benefits",
                "Inflammation to cancer",
                "When alcohol hits the cells",
                "Blackouts"
            ],
            "url": "https://wellawarecare.substack.com/p/hangovers"
        },
        {
            "id": "Health we inherit",
            "tldr": [
                "Trauma influences not just your mental health but your biology, increasing risks for chronic diseases like heart disease, cancer, and diabetes. ",
                "Tools like the ACE questionnaire link adverse childhood experiences to long-term health outcomes. ",
                "Your exposome\u2014the sum of everything you've been exposed to\u2014shapes your health more than your genes. ",
                "Epigenetics shows that trauma and environmental factors can reprogram your genes, affecting not just you but future generations. ",
                "Psychedelics, lifestyle changes, and epigenetic research offer groundbreaking approaches to healing trauma and reversing its effects."
            ],
            "connections": [
                "Your energy source",
                "Explosive & toxic chemicals in food",
                "The genetic disconnect",
                "Reorder mental disorder",
                "Brainiac strategies for the brain"
            ],
            "url": "https://wellawarecare.substack.com/p/health-we-inherit"
        },
        {
            "id": "High performance sleeping",
            "tldr": [
                "Sleep consistency is more crucial than total sleep duration for optimal health and performance. ",
                "Sleep timing and aligning with your circadian rhythm are key factors for maximizing brain and body performance. ",
                "Improved sleep can reduce cortisol, improve athletic performance, and enhance cognitive abilities. ",
                "Small sleep improvements, like adding 30 extra minutes, significantly boost immune function, reduce body fat, and improve recovery. ",
                "High-intensity exercise late in the evening can interfere with sleep quality, so switching to restorative exercises at night is recommended."
            ],
            "connections": [
                "Be better than the conventional normal",
                "How does fasting affect hormones?",
                "One third of your youth",
                "Detox with sleep",
                "Hold on to your strength",
                "No sweet dreams with sweets",
                "Zinc it up",
                "Brainiac strategies for the brain"
            ],
            "url": "https://wellawarecare.substack.com/p/high-performance-sleeping"
        },
        {
            "id": "Hold on to your strength",
            "tldr": [
                "Grip strength is a vital health marker, predicting risks like Alzheimer\u2019s and dementia. ",
                "Potassium is essential for muscle function, hydration, and heart health. ",
                "Vitamin D and balanced blood glucose levels prevent muscle fatigue and oxidative stress. ",
                "Creatine boosts muscle, bone, and brain health, enhancing strength and cognition. ",
                "Regular exercise and proper nutrition are keys to maintaining long-term health."
            ],
            "connections": [
                "Power up with potassium",
                "Take 11 minutes a day to postpone death",
                "Be better than the conventional normal",
                "Damn hard without vitamin D"
            ],
            "url": "https://wellawarecare.substack.com/p/hold-on-to-your-strength"
        },
        {
            "id": "How do you like them apples?",
            "tldr": [
                "Apple cider vinegar stabilizes blood sugar, managing glycation and supporting oxygen delivery, key factors for slowing aging. ",
                "As a prebiotic, it enhances gut health, serotonin production, and mood, benefiting brain health and neuroplasticity. ",
                "It supports fat burning and metabolic health, making it a valuable addition to a longevity-focused lifestyle. ",
                "Lowering Hemoglobin A1C levels with apple cider vinegar can reduce diabetes risk and improve overall well-being. ",
                "Incorporating apple cider vinegar aids in transitioning into a fasted state and amplifies the anti-aging effects of fasting."
            ],
            "connections": [
                "Functional medicine functioning",
                "Level up your gut!",
                "Belly fat!",
                "The healthy hungry age better",
                "Hack your fuel"
            ],
            "url": "https://wellawarecare.substack.com/p/how-do-you-like-them-apples"
        },
        {
            "id": "How does fasting affect hormones?",
            "tldr": [
                "Fasting boosts serotonin for better mood and sleep, increases growth hormone for anti-aging, and raises glucagon for fat burning. ",
                "Fasting can regulate blood sugar through adrenaline and cortisol, and help reverse leptin resistance. ",
                "Lack of sleep increases hunger hormones; glycine can improve insulin sensitivity and reduce kidney stone risk."
            ],
            "connections": [
                "The healthy hungry age better",
                "High performance sleeping",
                "Faster weight loss on slow thyroid",
                "Zinc it up",
                "Less (eating) is more (healthy)",
                "Insulin's hard problem",
                "Hack your fuel",
                "Detox with sleep"
            ],
            "url": "https://wellawarecare.substack.com/p/how-does-fasting-affect-hormones"
        },
        {
            "id": "Inflammation to cancer",
            "tldr": [
                "The immune system is vital in eliminating abnormal cells, including cancer. ",
                "Many cancers are influenced by environmental factors and lifestyle choices, not just genetics. ",
                "Chronic inflammation from modern stressors significantly increases cancer risk and other chronic diseases. ",
                "Reducing inflammation supports immune health and improves overall well-being. ",
                "Fourteen of the top fifteen leading causes of death are linked to chronic inflammation."
            ],
            "connections": [
                "Your energy source",
                "Ketogenic diet and cancer",
                "Non-food foods",
                "Prevent that cancer",
                "Starve that cancer",
                "The genetic disconnect"
            ],
            "url": "https://wellawarecare.substack.com/p/inflammation-to-cancer"
        },
        {
            "id": "Input equals IQ",
            "tldr": [
                "IQ is dynamic\u2014stress, toxins, habits, and belief systems can raise or lower it daily. ",
                "Cognitive performance thrives on novelty, nutrient density, and neural efficiency. ",
                "Intelligence is not fixed; genius is trained, not inherited. ",
                "Behavior, food, light, and peers act as brain upgrades or downgrades. ",
                "The brain\u2019s ability to grow (via BDNF and neuroplasticity) is responsive to friction, fasting, emotion, and movement."
            ],
            "connections": [
                "Forged in iron",
                "Hack your fuel",
                "Brain health 101",
                "Brainiac strategies for the brain",
                "Detox with sleep",
                "Preventing Alzheimer\u2019s with lifestyle choices"
            ],
            "url": "https://wellawarecare.substack.com/p/input-equals-iq"
        },
        {
            "id": "Inside job",
            "tldr": [
                "Your gut has more say in your mood, cravings, and clarity than you do. It runs on bacteria, not willpower. When it\u2019s balanced, you feel grounded and sharp. When it\u2019s off, everything from anxiety to appetite follows. Modern life\u2014processed food, stress, antibiotics, alcohol, and chemical residues\u2014reshapes this ecosystem daily. The real question isn\u2019t how your gut feels, but who\u2019s in charge of it: you or what you\u2019ve been feeding it."
            ],
            "connections": [
                "Fermented food benefits",
                "How do you like them apples?",
                "Level up your gut!",
                "Non-food foods"
            ],
            "url": "https://wellawarecare.substack.com/p/inside-job"
        },
        {
            "id": "Insulin's hard problem",
            "tldr": [
                "Insulin resistance happens when cell membranes stiffen, blocking nutrients and hormones. ",
                "Healthy fats, toxin reduction, and a positive mindset are key to reversing resistance. ",
                "Mitochondria thrive with fasting, organ meats, and red light exposure, boosting energy and detox. ",
                "Hormonal balance, particularly cortisol and oxytocin, improves insulin sensitivity. ",
                "Avoid frequent eating to prevent constant insulin spikes and support nutrient absorption."
            ],
            "connections": [
                "How does fasting affect hormones?",
                "One third of your youth",
                "The sugar consequences of salt",
                "Faster weight loss on slow thyroid",
                "Less (eating) is more (healthy)",
                "Hack your fuel",
                "Stress on purpose"
            ],
            "url": "https://wellawarecare.substack.com/p/insulins-hard-problem"
        },
        {
            "id": "Is organic food worth it?",
            "tldr": [
                "Organic food is better for preventing chronic diseases, but non-organic is okay if it has fewer pesticides and your health is good. ",
                "Pesticides can disrupt hormones, leading to issues like belly fat. ",
                "Glyphosate, a common pesticide, harms gut health and reduces biodiversity."
            ],
            "connections": [
                "Explosive & toxic chemicals in food",
                "Level up your gut!",
                "Functional medicine functioning",
                "Your energy source",
                "Non-food foods"
            ],
            "url": "https://wellawarecare.substack.com/p/care-12-is-organic-food-worth-it"
        },
        {
            "id": "Joint pain",
            "tldr": [
                "Joint pain is not an inevitable part of aging \u2014 it\u2019s a sign of metabolic, inflammatory, or gut dysfunction. ",
                "Your joints can become insulin resistant, just like your brain. ",
                "Leaky gut lets toxins like LPS reach the joints and trigger chronic inflammation. ",
                "Glycation from high blood sugar damages cartilage and increases creaking, pain, and stiffness. ",
                "Support joint health through anti-inflammatory foods, targeted compounds like L-carnitine and Boswellia, and prioritizing sleep and mobility."
            ],
            "connections": [
                "Insulin's hard problem",
                "Detox with sleep",
                "Hack your fuel",
                "Level up your gut!",
                "How do you like them apples?",
                "Comfy crash",
                "The real spice, girl!"
            ],
            "url": "https://wellawarecare.substack.com/p/joint-pain"
        },
        {
            "id": "Ketogenic diet and cancer",
            "tldr": [
                "The ketogenic diet starves cancer cells by limiting glucose, their primary fuel source, potentially slowing tumor growth. ",
                "Ketosis can reduce inflammation, enhance recovery, and potentially work synergistically with conventional treatments like chemotherapy. ",
                "Addressing mitochondrial health and the body\u2019s signaling systems is crucial in understanding cancer\u2019s complexities and potential treatment strategies. ",
                "Embracing a holistic approach, including diet, sleep, and emotional well-being, may offer new hope in cancer care."
            ],
            "connections": [
                "Functional medicine functioning",
                "The real spice, girl!",
                "Preventing Alzheimer\u2019s with lifestyle choices",
                "Take 11 minutes a day to postpone death",
                "The healthy hungry age better",
                "Your energy source",
                "Starve that cancer",
                "Prevent that cancer",
                "Inflammation to cancer",
                "Detox with sleep"
            ],
            "url": "https://wellawarecare.substack.com/p/ketogenic-diet-and-cancer"
        },
        {
            "id": "Lactose in-tolerance?",
            "tldr": [
                "Around 65% of the global population is lactose intolerant, and the prevalence increases with age. ",
                "Lactose intolerance symptoms occur when the body cannot properly digest dairy\u2019s carbohydrate content due to low levels of lactase. ",
                "Gut health and skin conditions are closely linked, making dairy intolerance a potential trigger for skin issues like acne and eczema. ",
                "Dairy alternatives and lactase enzymes can offer solutions, but eliminating dairy often improves gut health. ",
                "Non-dairy sources of calcium, such as almonds, sardines, and leafy greens, provide nutrient-rich alternatives to dairy."
            ],
            "connections": [
                "Level up your gut!",
                "Explosive & toxic chemicals in food",
                "Vitamin D Deficiency",
                "Damn hard without vitamin D"
            ],
            "url": "https://wellawarecare.substack.com/p/lactose-in-tolerance"
        },
        {
            "id": "Lean mean double green",
            "tldr": [
                "Spirulina and chlorella are among the most nutrient-dense foods, with spirulina excelling in energy production and chlorella in detoxification. ",
                "Spirulina contains superoxide dismutase (SOD), an antioxidant critical for mitochondrial function and cellular protection, but its production declines after age 30. ",
                "Chlorella binds to heavy metals, pesticides, and alcohol byproducts, assisting in detoxification and reducing oxidative stress. ",
                "Phycocyanin, a unique compound in spirulina, enhances energy production in healthy cells but triggers cell death in cancerous or senescent cells. ",
                "The quality of spirulina and chlorella matters\u2014contaminated sources may contain harmful toxins."
            ],
            "connections": [
                "Your energy source",
                "Non-food foods",
                "Master of detox",
                "One third of your youth"
            ],
            "url": "https://wellawarecare.substack.com/p/lean-mean-double-green"
        },
        {
            "id": "Less (eating) is more (healthy)",
            "tldr": [
                "Fasting progresses through six stages, from blood sugar stabilization to immune regeneration, offering diverse health benefits. ",
                "Drinks like water, tea, and coffee support fasting, but additives like sugar or alcohol disrupt its effects. ",
                "Prolonged fasting activates autophagy and stem cell regeneration, enhancing cellular cleanup and immune health. ",
                "Explore fasting\u2019s physiological changes, from fat burning to immune renewal."
            ],
            "connections": [
                "Faster weight loss on slow thyroid",
                "The healthy hungry age better",
                "Your energy source",
                "Belly fat!",
                "How does fasting affect hormones?",
                "Level up your gut!",
                "Prevent that cancer",
                "Starve that cancer"
            ],
            "url": "https://wellawarecare.substack.com/p/less-eating-is-more-healthy"
        },
        {
            "id": "Level up your gut!",
            "tldr": [
                "Eat a variety of fiber-rich and fermented foods for a diverse gut microbiome. ",
                "Avoid sugar, alcohol, antibiotics, GMO foods, and artificial sweeteners to maintain gut diversity. ",
                "Intermittent fasting and coffee (without sugar/milk) support gut health and overall well-being. ",
                "A healthy microbiome aids immune function, hormone regulation, and mood."
            ],
            "connections": [
                "Explosive & toxic chemicals in food",
                "Level up your gut!",
                "Bread!",
                "Is organic food worth it?",
                "Non-food foods",
                "Lactose in-tolerance?",
                "Fermented food benefits",
                "Supplementation is not expensive urine"
            ],
            "url": "https://wellawarecare.substack.com/p/level-up-your-gut"
        },
        {
            "id": "Life lemon duo",
            "tldr": [
                "We all carry moments our minds can\u2019t name. When something overwhelms us before we can explain it, the body takes the record. Muscles tighten, breath shortens, heart rhythm shifts\u2014and long after the event fades, the body still prepares for danger. Trauma isn\u2019t just what happened; it\u2019s what stays when we had no way to fight, flee, or speak."
            ],
            "connections": [
                "Mind at volume",
                "Health we inherit",
                "Reorder mental disorder",
                "Right brain is right",
                "Complexities of depression"
            ],
            "url": "https://wellawarecare.substack.com/p/life-lemon-duo"
        },
        {
            "id": "Master of detox",
            "tldr": [
                "Glutathione is crucial for detoxifying the body and combating oxidative stress. ",
                "Traditional methods like IV or oral supplements have absorption challenges, but topical applications offer better delivery. ",
                "Glutathione enhances anti-aging, detoxification, and skin health when applied topically. ",
                "It helps balance hormones by removing endocrine-disrupting toxins from the body. ",
                "Supporting glutathione levels boosts mitochondrial health, energy, and cellular repair."
            ],
            "connections": [
                "Supplements for your pretty face",
                "Femme fatale fragrance",
                "Don't de-health while deodorizing",
                "Nasties in beauty",
                "The genetic disconnect",
                "Zinc it up"
            ],
            "url": "https://wellawarecare.substack.com/p/master-of-detox"
        },
        {
            "id": "Meat (head) and iron (maiden)",
            "tldr": [
                "Protein is the only macronutrient required in large amounts, while carbohydrates are non-essential. ",
                "DNA\u2019s primary function is protein synthesis, assembling amino acids into structures like muscles, bones, and immune cells. ",
                "Muscle loss is a major driver of aging, increasing inflammation, insulin resistance, and hormonal dysfunction. ",
                "Protein digestion efficiency depends on stomach acid (HCL) and digestive enzymes\u2014poor digestion leads to nutrient deficiencies and metabolic dysfunction. ",
                "Heme iron from animal protein is the most absorbable form, while plant-based iron is poorly absorbed and often bound to anti-nutrients."
            ],
            "connections": [
                "Hack your fuel",
                "Is organic food worth it?",
                "Lactose in-tolerance?",
                "Pick not Ozempic"
            ],
            "url": "https://wellawarecare.substack.com/p/meat-head-and-iron-maiden"
        },
        {
            "id": "Mind at volume",
            "tldr": [
                "Your inner voice is your mind\u2019s narrator\u2014the one rehearsing, remembering, warning, and planning. It\u2019s essential for self-control, motivation, and focus. But when the voice turns up too loud, thought becomes noise. The same mechanism that lets us reflect can trap us in loops of rumination, regret, and worry. Understanding when the inner voice helps\u2014and when it harms\u2014is how we turn chatter back into clarity."
            ],
            "connections": [
                "Life lemon duo",
                "Brain health 101"
            ],
            "url": "https://wellawarecare.substack.com/p/mind-at-volume"
        },
        {
            "id": "Nasties in beauty",
            "tldr": [
                "Silicone breast implants can leach harmful substances like platinum, causing inflammation and health risks. ",
                "Makeup removers and beauty products often include chemicals that increase toxin absorption through the skin. ",
                "Phthalates in fragrances disrupt hormones, reducing testosterone and affecting fertility. ",
                "BPA in plastics and beauty packaging promotes weight gain and metabolic issues. ",
                "A minimalist, natural approach to skincare reduces toxic exposure, supports hormone balance, and improves detox pathways."
            ],
            "connections": [
                "Femme fatale fragrance",
                "Bonds, alpha females & botox",
                "The real spice, girl!",
                "The genetic disconnect"
            ],
            "url": "https://wellawarecare.substack.com/p/nasties-in-beauty"
        },
        {
            "id": "No sweet dreams with sweets",
            "tldr": [
                "Poor sleep increases cravings for sugary foods and disrupts metabolism. ",
                "Lemon juice, lime juice, and cinnamon can naturally regulate blood sugar spikes. ",
                "Berberine is a potent natural glucose regulator comparable to metformin. ",
                "Excess sugar worsens ADHD symptoms, while omega-3s can improve focus and mood. ",
                "Prioritizing sleep and a balanced diet supports sugar metabolism and reduces cravings."
            ],
            "connections": [
                "High performance sleeping",
                "Non-food foods",
                "The sugar consequences of salt",
                "Detox with sleep",
                "Sweet and salty sugar"
            ],
            "url": "https://wellawarecare.substack.com/p/no-sweet-dreams-with-sweets"
        },
        {
            "id": "Non-food foods",
            "tldr": [
                "Excessive sugar intake and ultra-processed foods are linked to metabolic disorders, cognitive decline, and mental health issues. ",
                "Aspartame and non-nutritive sweeteners may impact cognitive health by disrupting neurotransmitters and gut microbiome balance. ",
                "Even moderate alcohol consumption affects brain structure and function, increasing cancer risks and psychological dependence. ",
                "Seed oils high in omega-6 fatty acids contribute to inflammation, oxidative stress, and mitochondrial damage, potentially due to misleading health recommendations."
            ],
            "connections": [
                "The sugar consequences of salt",
                "Explosive & toxic chemicals in food",
                "Is organic food worth it?",
                "Level up your gut!",
                "Brain health 101",
                "Your energy source",
                "Power up with potassium",
                "Prevent that cancer",
                "Starve that cancer"
            ],
            "url": "https://wellawarecare.substack.com/p/non-food-foods"
        },
        {
            "id": "One third of your youth",
            "tldr": [
                "Glycine, vital for collagen production, is often deficient in modern diets, leading to various health issues. ",
                "It supports antioxidant production, liver detoxification, and gut health, helping to prevent autoimmune diseases. ",
                "Glycine enhances sleep, insulin sensitivity, and blood sugar regulation, making it valuable for managing conditions like gout and fatty liver. ",
                "It can also prevent kidney stones and improve overall metabolic health by balancing insulin and glucagon. ",
                "Simple dietary changes, such as consuming gelatin or bone broth, can boost glycine intake."
            ],
            "connections": [
                "Your energy source",
                "Supplements for your pretty face",
                "Level up your gut!",
                "High performance sleeping",
                "Fermented food benefits",
                "The genetic disconnect",
                "Hack your fuel",
                "Master of detox",
                "Detox with sleep"
            ],
            "url": "https://wellawarecare.substack.com/p/one-third-of-your-youth"
        },
        {
            "id": "Out of focus",
            "tldr": [
                "Vision isn\u2019t just about seeing clearly\u2014it\u2019s about how the brain, light, and metabolism talk to each other. The loss of near focus we call _presbyopia_ isn\u2019t simply age; it\u2019s often a slow adaptation to how we live and light ourselves. From screen strain to sunlight deficit, our eyes mirror our daily habits. The same systems that help us focus visually also anchor our attention, mood, and energy. When vision fades, it may be signaling that the rest of the body\u2014and mind\u2014has drifted out of focus too."
            ],
            "connections": [
                "Damn hard without vitamin D",
                "Inside job"
            ],
            "url": "https://wellawarecare.substack.com/p/out-of-focus"
        },
        {
            "id": "Peaked at 25",
            "tldr": [
                "Peak span is the duration of life spent within 90% of peak physical and cognitive function. Essential biological markers\u2014including muscle mass and bone density\u2014typically peak at age 25 before entering a steady physiological decline. Sustaining this peak requires active intervention to prevent the natural shedding of structural tissue and the erosion of cognitive reserves."
            ],
            "connections": [
                "Working workout",
                "Get muscle mass.ive",
                "Power powder",
                "Be better than the conventional normal",
                "Hack your fuel",
                "Stress on purpose"
            ],
            "url": "https://wellawarecare.substack.com/p/peaked-at-25"
        },
        {
            "id": "Pick not Ozempic",
            "tldr": [
                "Willpower is no match for your evolutionary instincts, which prioritize survival over food control. ",
                "Stress, sleep deprivation, and ultra-processed foods worsen cravings and disrupt appetite hormones. ",
                "Drugs like Ozempic can help with weight loss but don\u2019t address behavioral changes or root causes. ",
                "Muscle loss, slower metabolism, and severe side effects are significant downsides of long-term Ozempic use. ",
                "\u201CIf you're a severely obese person, you have severe health conditions, you're really struggling to get going, can it be a helpful aid? Absolutely. Should it be given to everybody who wants to look good for a party or a wedding? Absolutely not.\u201D"
            ],
            "connections": [
                "Your energy source",
                "Hold on to your strength"
            ],
            "url": "https://wellawarecare.substack.com/p/pick-not-ozempic"
        },
        {
            "id": "Power powder",
            "tldr": [
                "Visible fatigue is often the final stage of a deeper systemic drain. Research suggests that nearly half of adults under 40\u2014and nearly everyone over 40\u2014exhibits signs of mitochondrial dysfunction, regardless of whether they \u201Cfeel\u201D tired. Creatine acts as a foundational energy buffer, moving beyond its reputation as a bodybuilding supplement to serve as a critical regulator for cellular stability, cognitive processing, and systemic longevity."
            ],
            "connections": [
                "Get muscle mass.ive",
                "Hold on to your strength"
            ],
            "url": "https://wellawarecare.substack.com/p/power-powder"
        },
        {
            "id": "Power up with potassium",
            "tldr": [
                "Potassium is a critical nutrient with a daily requirement of 4700 milligrams, far exceeding most people\u2019s intake. ",
                "A deficiency in potassium can lead to muscle cramps, high blood pressure, and heart palpitations, among other issues. ",
                "Processed foods, high-carb diets, and certain medications can deplete potassium levels. ",
                "Including potassium-rich foods, hydrating properly, and being mindful during fasting can prevent serious imbalances."
            ],
            "connections": [
                "Your energy source",
                "Supplements for your pretty face",
                "Zinc it up",
                "When alcohol hits the cells",
                "Hack your fuel",
                "Hangovers",
                "Hold on to your strength",
                "Stress on purpose",
                "Damn hard without vitamin D"
            ],
            "url": "https://wellawarecare.substack.com/p/power-up-with-potassium"
        },
        {
            "id": "Prevent that cancer",
            "tldr": [
                "Fasting protocols like OMAD and 48-hour fasts help suppress cancer growth and enhance chemotherapy\u2019s effectiveness. ",
                "Fasting reduces inflammation, promotes autophagy, and lowers IGF and mTOR levels, all key to cancer prevention. ",
                "Natural remedies like curcumin, garlic, and black seed oil complement fasting by inhibiting cancer growth. ",
                "Alcohol\u2019s DNA-altering toxins increase cancer risks, especially for breast cancer. ",
                "Regular exercise combined with fasting lowers the risk of cancer and other chronic diseases."
            ],
            "connections": [
                "Ketogenic diet and cancer",
                "Non-food foods",
                "Take 11 minutes a day to postpone death",
                "The healthy hungry age better",
                "Don't de-health while deodorizing",
                "The real spice, girl!",
                "Nasties in beauty",
                "Alcohol & DNA",
                "Inflammation to cancer",
                "Starve that cancer",
                "Can't lose weight?",
                "Health we inherit"
            ],
            "url": "https://wellawarecare.substack.com/p/prevent-that-cancer"
        },
        {
            "id": "Preventing Alzheimer\u2019s with lifestyle choices",
            "tldr": [
                "Up to 40% of Alzheimer\u2019s cases are linked to modifiable lifestyle factors. ",
                "Factors like gender, diet, exercise, sleep, and metabolic health significantly impact Alzheimer\u2019s risk. ",
                "Avoiding processed foods, supporting metabolic health, and eating brain-boosting nutrients like DHA from fish and antioxidants can reduce the risk of cognitive decline."
            ],
            "connections": [
                "Brain health 101",
                "Effects of mouth's proximity to the brain",
                "Non-food foods",
                "Hold on to your strength",
                "Detox with sleep",
                "Brainiac strategies for the brain",
                "Reorder mental disorder",
                "Insulin's hard problem"
            ],
            "url": "https://wellawarecare.substack.com/p/preventing-alzheimers-with-lifestyle"
        },
        {
            "id": "Push against gravity",
            "tldr": [
                "We think of gravity as background physics, but it\u2019s an active biological force shaping mood, metabolism, and resilience. Every cell evolved under its pull, yet modern life minimizes exposure\u2014chairs, shoes, and flights quietly erode our anti-gravity systems. The body weakens not from age alone but from disuse of the very force that keeps it upright."
            ],
            "connections": [
                "Be better than the conventional normal",
                "Get muscle mass.ive",
                "Hack your fuel",
                "Hold on to your strength"
            ],
            "url": "https://wellawarecare.substack.com/p/push-against-gravity"
        },
        {
            "id": "Quiet Fire",
            "tldr": [
                "Inflammation is often associated with injury or illness, yet most modern inflammation operates quietly. It persists without obvious symptoms, driven less by acute threats and more by ongoing system interactions\u2014particularly between the gut, immune signaling, microbes, and metabolism. Understanding inflammation requires looking at how these elements stay connected long after the original trigger has passed."
            ],
            "connections": [
                "Hack your fuel",
                "Inflammation to cancer",
                "Inside job",
                "Joint pain",
                "Ketogenic diet and cancer",
                "Lactose in-tolerance?",
                "Lean mean double green",
                "Meat (head) and iron (maiden)",
                "Non-food foods",
                "Prevent that cancer"
            ],
            "url": "https://wellawarecare.substack.com/p/quiet-fire"
        },
        {
            "id": "Reorder mental disorder",
            "tldr": [
                "Mental disorders often stem from metabolic dysfunction, particularly mitochondrial impairment. ",
                "Trauma survivors frequently suffer from mitochondrial imbalances, leading to both physical and mental health challenges. ",
                "Medications for mental disorders can harm mitochondrial function, causing side effects like weight gain and diabetes. ",
                "A whole food, low-glycemic diet, potentially ketogenic, supports mitochondrial repair and mental health. ",
                "Neurons and glial cells have distinct energy preferences, and balancing them can optimize brain function."
            ],
            "connections": [
                "Brain health 101",
                "Effects of mouth's proximity to the brain",
                "Welcome the suck",
                "Detox with sleep",
                "Fermented food benefits",
                "Brainiac strategies for the brain",
                "Complexities of depression",
                "Health we inherit"
            ],
            "url": "https://wellawarecare.substack.com/p/reorder-mental-disorder"
        },
        {
            "id": "Right brain is right",
            "tldr": [
                "The right brain is our lifelong anchor for emotion, safety, and connection\u2014and it matures in the first 24 months of life. ",
                "Attachment isn\u2019t just psychological. It\u2019s psychobiological, shaping how we regulate emotional arousal via the autonomic nervous system. ",
                "Regulation theory reveals that intimacy, eye contact, music, and even scent can rewire our nervous system and heal attachment wounds. ",
                "Empathy is more than a concept. It\u2019s a full-body, right-brain-to-right-brain resonance\u2014and texting can\u2019t replicate it. ",
                "Trust, safety, and emotional transformation happen in spontaneous, embodied, co-regulated exchanges\u2014not in emoji."
            ],
            "connections": [
                "Socialized wellness",
                "Brainiac strategies for the brain",
                "Reorder mental disorder"
            ],
            "url": "https://wellawarecare.substack.com/p/right-brain-is-right"
        },
        {
            "id": "Rot is in the air",
            "tldr": [
                "Mold is not just a moisture problem\u2014it\u2019s a chronic health disruptor hiding in dust, HVAC systems, and furniture. ",
                "Indoor air can be up to 100x more polluted than outdoor air due to synthetic materials, poor ventilation, and off-gassing. ",
                "Dead mold still causes reactions; most remediation misses spores, dust, and HVAC infiltration. ",
                "Particles and VOCs (volatile organic compounds) pass into the bloodstream through inhalation and impact everything from immunity to cognition. ",
                "Detoxification starts with prevention: filter your air, sweat often, upgrade your bedding, and let your liver work, not fight."
            ],
            "connections": [
                "Functional medicine functioning",
                "Don't de-health while deodorizing",
                "Master of detox"
            ],
            "url": "https://wellawarecare.substack.com/p/rot-is-in-the-air"
        },
        {
            "id": "Smell it out",
            "tldr": [
                "Smell and taste subconsciously shape social interactions, from pheromone detection to trust-building. ",
                "Gender differences and hormonal shifts play a key role in odor perception and relationship dynamics. ",
                "Chemical exchanges via breath, skin, and touch guide human decisions and deepen connections. ",
                "Handshakes, shared spaces, and tears involve chemical sensing, influencing interpersonal bonds. ",
                "Sensory behaviors, though subtle, have profound effects on everyday life, including partner selection and trust."
            ],
            "connections": [
                "Bonds, alpha females & botox"
            ],
            "url": "https://wellawarecare.substack.com/p/smell-it-out"
        },
        {
            "id": "Socialized wellness",
            "tldr": [
                "Relationships are a central, underappreciated driver of both health and longevity. ",
                "Social genomics shows our gene expression shifts depending on the quality of our relationships\u2014love dampens inflammation, conflict fans its flames. ",
                "The quality of your social circle affects your risk of obesity, chronic disease, depression, and even early death. ",
                "Deep emotional connections\u2014like those felt when calling someone to share good news\u2014regulate our physiology and even synchronize heart and brain waves. ",
                "Being in a bad relationship, or lacking meaningful friendships, increases disease risk as much as smoking or poor diet."
            ],
            "connections": [
                "Smell it out",
                "Bonds, alpha females & botox",
                "Brain health 101"
            ],
            "url": "https://wellawarecare.substack.com/p/socialized-wellness"
        },
        {
            "id": "Spermi got nerdy",
            "tldr": [
                "Spermidine is a naturally occurring postbiotic and polyamine essential for cell survival, longevity, and autophagy. ",
                "It mimics and enables fasting by triggering autophagy, mitophagy, and cellular renewal. ",
                "Spermidine levels decline with age and are difficult to replenish adequately through diet alone. ",
                "Supplementation improves mitochondrial function, supports brain and kidney health, and reduces inflammation. ",
                "Topical spermidine has shown benefits for collagen production, skin tone, and hair growth."
            ],
            "connections": [
                "Master of detox",
                "Level up your gut!",
                "One third of your youth",
                "Supplements for your pretty face",
                "Your energy source"
            ],
            "url": "https://wellawarecare.substack.com/p/spermi-got-nerdy"
        },
        {
            "id": "Starve that cancer",
            "tldr": [
                "Ketogenic diets and fasting are emerging as effective tools in cancer prevention and treatment. ",
                "Ketosis inhibits cancer growth, reduces inflammation, and enhances cell renewal via autophagy. ",
                "Pairing chemotherapy with ketosis shows promise in improving treatment outcomes. ",
                "Lifestyle factors like sleep, light exposure, and emotional well-being are vital in cancer prevention. ",
                "Optimizing mitochondrial health and adopting holistic practices ensure long-term wellness."
            ],
            "connections": [
                "Ketogenic diet and cancer",
                "Non-food foods",
                "Take 11 minutes a day to postpone death",
                "The healthy hungry age better",
                "Don't de-health while deodorizing",
                "The real spice, girl!",
                "Inflammation to cancer",
                "Nasties in beauty",
                "Prevent that cancer",
                "Alcohol & DNA",
                "Can't lose weight?",
                "Health we inherit"
            ],
            "url": "https://wellawarecare.substack.com/p/starve-that-cancer"
        },
        {
            "id": "Stress on purpose",
            "tldr": [
                "Stress isn\u2019t the enemy; improper recovery is. Embrace hormesis \u2013 purposeful stress like fasting, exercise, and cold exposure \u2013 to strengthen the body and mind. ",
                "Mitochondria, your cellular powerhouses, produce 16x more energy in the presence of oxygen. Aging accelerates with hypoxia. ",
                "The aggressive pursuit of comfort speeds up aging. Stress adaptation (e.g., through sprinting, fasting, cold exposure) unlocks resilience. ",
                "Sleep quality directly impacts longevity. Your brain\u2019s glymphatic system clears waste and inflammation during deep sleep. ",
                "Nutrient deficiencies, not genetics, drive most chronic diseases. Identify and supplement deficiencies to regain health."
            ],
            "connections": [
                "Your energy source",
                "Hold on to your strength",
                "High performance sleeping"
            ],
            "url": "https://wellawarecare.substack.com/p/stress-on-purpose"
        },
        {
            "id": "Super sea food",
            "tldr": [
                'Modern environmental stressors place an unprecedented load on the body\'s natural detoxification and energy pathways. While often dismissed as a generic superfood, spirulina and chlorella are biologically distinct organisms that function as systemic "cleaners" and "rechargers." These algae provide a nutrient density 1,000 times greater than any other fruit or vegetable, offering a mechanical solution to cellular inflammation and toxic accumulation.'
            ],
            "connections": [
                "Lean mean double green"
            ],
            "url": "https://wellawarecare.substack.com/p/super-sea-food"
        },
        {
            "id": "Supplementation is not expensive urine",
            "tldr": [
                "Foundational supplements provide essential nutrients, digestive enzymes, and adaptogens to bridge dietary gaps. ",
                "Single-ingredient formulations target specific deficiencies with precision and avoid unnecessary compounds. ",
                "Balance fat-soluble (A, D, E, K) and water-soluble vitamins to optimize health and prevent toxicity. ",
                "Gut health support through probiotics, prebiotics, and digestive enzymes enhances nutrient absorption and overall wellness. ",
                "Tailor supplementation to your lifestyle, diet, and unique needs for maximum benefit."
            ],
            "connections": [
                "Power up with potassium",
                "Supplements for your pretty face",
                "Brain health 101",
                "Damn hard without vitamin D",
                "Vitamin D Deficiency"
            ],
            "url": "https://wellawarecare.substack.com/p/supplementation-is-not-expensive-urine"
        },
        {
            "id": "Supplements for your pretty face",
            "tldr": [
                "Mitochondria are your body\u2019s energy factories, and supporting their function is crucial for anti-aging and vitality. ",
                "Glutathione not only detoxifies your liver but also strengthens mitochondrial health. ",
                "Clean beauty products can reduce exposure to hormonal disruptors, supporting both skin and hormonal balance. ",
                "By focusing on mitochondrial health and clean beauty, you can boost energy, improve skin, and enhance overall well-being."
            ],
            "connections": [
                "One third of your youth",
                "Don't de-health while deodorizing",
                "Bonds, alpha females & botox",
                "Your energy source",
                "Femme fatale fragrance",
                "Nasties in beauty",
                "Master of detox",
                "Supplementation is not expensive urine",
                "Damn hard without vitamin D",
                "Lactose in-tolerance?",
                "Zinc it up"
            ],
            "url": "https://wellawarecare.substack.com/p/supplements-for-your-pretty-face"
        },
        {
            "id": "Sweet and salty sugar",
            "tldr": [
                "Neuropod cells in the gut communicate with the brain, influencing sugar cravings and dopamine release. ",
                "Hidden sugars in foods can trick your taste buds and drive overconsumption. ",
                "Glycemic Index (GI) impacts sugar cravings, with lower-GI foods moderating blood sugar spikes and dopamine response. ",
                "Strategies like fiber pairing and low-GI choices help manage sugar cravings and stabilize energy. ",
                "Omega-3 fatty acids and glutamine may reduce sugar cravings by influencing gut-brain communication."
            ],
            "connections": [
                "Non-food foods",
                "Your energy source",
                "Fruit juice to fatty liver",
                "Be better than the conventional normal",
                "Starve that cancer",
                "Less (eating) is more (healthy)",
                "No sweet dreams with sweets"
            ],
            "url": "https://wellawarecare.substack.com/p/sweet-and-salty-sugar"
        },
        {
            "id": "Take 11 minutes a day to postpone death",
            "tldr": [
                "Regular exercise is the most potent natural remedy for living longer and reducing disease risk. ",
                'Building a "fitness reserve" gives your body a health buffer to counter stress, improve metabolism, and enhance flexibility. ',
                "Short bursts of high-intensity exercise throughout the day can dramatically lower mortality rates and reduce risks of cardiovascular disease and cancer. ",
                "Activities like walking after meals, using tools like the Relentless Rope Trainer and mobility sticks, and even sauna sessions can boost fitness and support overall well-being. ",
                "Consistency in enjoyable fitness activities and using heart rate variability (HRV) technology to monitor stress and recovery can optimize exercise routines."
            ],
            "connections": [
                "Your energy source",
                "Hold on to your strength"
            ],
            "url": "https://wellawarecare.substack.com/p/take-11-minutes-a-day-to-postpone"
        },
        {
            "id": "The dark light",
            "tldr": [
                "You\u2019ve been taught to fear sunlight and ignore indoor light. You protect your skin, dim your screens, and assume light only matters when you can see it. But most of what shapes your cells is invisible. Different wavelengths of light are absorbed, reflected, or scattered through your body\u2014changing how your mitochondria work, how your eyes age, and how your metabolism responds."
            ],
            "connections": [
                "Out of focus",
                "Vitamin D Deficiency"
            ],
            "url": "https://wellawarecare.substack.com/p/the-dark-light"
        },
        {
            "id": "The genetic disconnect",
            "tldr": [
                "Our genes remain largely unchanged for 250,000 years, yet modern life introduces stressors that our bodies aren't designed to handle. ",
                "Epigenetics, influenced by diet and environment, determines how genes are expressed and can affect future generations. ",
                "Environmental toxins, such as plastics and phthalates, disrupt hormones and gene expression, contributing to health challenges like infertility and cognitive decline. ",
                "mRNA and CRISPR technologies are revolutionizing genetic science but carry unknown long-term risks. ",
                "Managing environmental and lifestyle factors is essential for adapting to modern challenges and maintaining genetic health."
            ],
            "connections": [
                "Preventing Alzheimer\u2019s with lifestyle choices",
                "Femme fatale fragrance",
                "Brain health 101",
                "Insulin's hard problem",
                "Inflammation to cancer",
                "Nasties in beauty"
            ],
            "url": "https://wellawarecare.substack.com/p/the-genetic-disconnect"
        },
        {
            "id": "The healthy hungry age better",
            "tldr": [
                "Fasting is not only safe but essential for older adults, offering numerous benefits like life extension and activation of anti-aging genes. ",
                "It helps alleviate age-related health issues such as obesity, high blood pressure, and dementia by promoting metabolic flexibility. ",
                "Fasting supports DNA and mitochondrial repair through autophagy, enhancing cellular function and reducing cancer risk. ",
                "It boosts heart and brain health by increasing ketone production and stimulating neuronal regeneration with BDNF. ",
                "The practice enhances the body's antioxidant network, reducing free radical damage and supporting cardiovascular health."
            ],
            "connections": [
                "How does fasting affect hormones?",
                "Brain health 101",
                "Your energy source",
                "Less (eating) is more (healthy)",
                "Faster weight loss on slow thyroid",
                "When to eat?",
                "Hack your fuel"
            ],
            "url": "https://wellawarecare.substack.com/p/the-healthy-hungry-age-better"
        },
        {
            "id": "The real spice, girl!",
            "tldr": [
                "Turmeric, used in ancient medicine, contains curcumin, a powerful polyphenol with poor natural absorption. ",
                "For better absorption, pair turmeric with black pepper or supplements containing bioparen. ",
                "Curcumin reduces dementia risk, supports brain health, alleviates joint pain, and even fights cancer. ",
                "Turmeric aids women\u2019s health by improving mood and managing PMS symptoms. ",
                "High-polyphenol spices like turmeric promote gut health and weight management."
            ],
            "connections": [
                "Brain health 101",
                "Level up your gut!",
                "Prevent that cancer",
                "Inflammation to cancer",
                "Hack your fuel"
            ],
            "url": "https://wellawarecare.substack.com/p/the-real-spice-girl"
        },
        {
            "id": "The sugar consequences of salt",
            "tldr": [
                "Fructose is produced in the liver when glucose is high and causes insulin resistance, leading to fat gain and metabolic syndrome. ",
                "High salt intake without enough water triggers fructose production and fat storage, contributing to metabolic problems. ",
                "Fructose and certain foods raise uric acid levels, causing oxidative stress and a cycle of increased fructose production, worsening obesity. ",
                "High fructose and uric acid levels damage blood vessels, making arterial plaque stickier and increasing heart disease risk."
            ],
            "connections": [
                "Your energy source",
                "Fruit juice to fatty liver",
                "One third of your youth",
                "Non-food foods",
                "Starve that cancer",
                "Hold on to your strength"
            ],
            "url": "https://wellawarecare.substack.com/p/the-sugar-consequences-of-salt"
        },
        {
            "id": "Toxic traditions",
            "tldr": [
                "Many modern rituals introduce large, short-term toxin spikes into air, water, and soil\u2014often without awareness or consent. Fireworks, wildfire smoke, and industrial chemicals don\u2019t act in isolation. They interact with lungs, blood, brain, and endocrine systems, creating cumulative effects that persist long after the event itself ends. Understanding toxin exposure requires seeing how cultural practices and environmental chemistry intersect."
            ],
            "connections": [
                "Effects of mouth's proximity to the brain",
                "Explosive & toxic chemicals in food",
                "Femme fatale fragrance",
                "Lean mean double green",
                "Master of detox",
                "Rot is in the air",
                "Don't de-health while deodorizing"
            ],
            "url": "https://wellawarecare.substack.com/p/toxic-traditions"
        },
        {
            "id": "Unmanned man",
            "tldr": [
                "A generation of men feels aimless, addicted, or disconnected not because they\u2019re weak, but because they\u2019ve lost touch with their _Why_. When reward becomes easier than effort, and stimulation replaces purpose, the brain stops pushing forward. Addiction, distraction, and numbness aren\u2019t failures of discipline, they\u2019re signs of a mind that has stopped believing its actions matter."
            ],
            "connections": [
                "Grit, Glucose & Grind",
                "Socialized wellness",
                "Y make a man",
                "Be better than the conventional normal",
                "Welcome the suck"
            ],
            "url": "https://wellawarecare.substack.com/p/unmanned-man"
        },
        {
            "id": "Vampire queen",
            "tldr": [
                "When estrogen begins to fade, the brain feels it first. Energy falls, heat rises, and clarity flickers. It can feel like the light is draining out\u2014but this isn\u2019t decay; it\u2019s conversion. The menopausal brain stops feeding on the old fuel and learns to make its own. The same networks that once depended on hormonal energy start reorganizing for endurance. Understanding this shift turns menopause from a story of loss into one of transformation."
            ],
            "connections": [
                "Functional medicine functioning",
                "Master of detox",
                "Supplements for your pretty face"
            ],
            "url": "https://wellawarecare.substack.com/p/vampire-queen"
        },
        {
            "id": "Vitamin D Deficiency",
            "tldr": [
                "Supplement vitamin D through food when sunlight is insufficient. ",
                "Darker skin requires more sunlight. ",
                "Symptoms of vitamin D deficiency include bone loss, pain, low immunity, depression, high blood pressure, and inflammation. ",
                "Additionally, there are over 20 lesser-known symptoms, such as nightmares, acne, and vertigo.  "
            ],
            "connections": [
                "Be better than the conventional normal",
                "Explosive & toxic chemicals in food",
                "Functional medicine functioning",
                "Supplementation is not expensive urine",
                "Nasties in beauty",
                "Hold on to your strength",
                "Damn hard without vitamin D"
            ],
            "url": "https://wellawarecare.substack.com/p/care-10-vitamin-d-deficiency"
        },
        {
            "id": "Welcome the suck",
            "tldr": [
                "Happiness is a balance of enjoyment, satisfaction, and meaning, and is processed differently in the brain. ",
                "Struggling, deferred gratification, and effort are necessary components of long-term satisfaction. ",
                "Suffering is essential for growth and self-awareness, and embracing it can lead to a deeper sense of happiness. ",
                "Deep relationships, meaningful work, and teaching others play critical roles in achieving happiness and mastery."
            ],
            "connections": [
                "How does fasting affect hormones?",
                "Reorder mental disorder"
            ],
            "url": "https://wellawarecare.substack.com/p/welcome-the-suck"
        },
        {
            "id": "When alcohol hits the cells",
            "tldr": [
                "Alcohol penetrates every cell due to its water- and fat-soluble nature, causing widespread effects. ",
                "Even low alcohol intake (1-2 drinks/day) can thin the neocortex, a brain region vital for memory and self-regulation. ",
                "Regular drinkers feel prolonged euphoria due to neural changes, while occasional drinkers experience quicker cognitive declines. ",
                "High alcohol consumption (12+ drinks/week) is strongly tied to neurodegeneration. ",
                "Starting to drink young dramatically increases the risk of alcohol dependence. ",
                "Alcohol transforms into toxic byproducts like acetaldehyde, disrupting cellular and neural health."
            ],
            "connections": [
                "Brain health 101",
                "Alcohol & DNA",
                "Blackouts",
                "Hangovers",
                "Brainiac strategies for the brain"
            ],
            "url": "https://wellawarecare.substack.com/p/when-alcohol-hits-the-cells"
        },
        {
            "id": "When to eat?",
            "tldr": [
                "When you eat is as important as what you eat for health, especially liver and mental health. ",
                "Time-restricted feeding (TRF) helps align your body's 24-hour rhythm (circadian clock), boosting health and reducing risks. ",
                "Eating during your active phase of the day (daylight hours) enhances metabolic health and prevents liver damage. ",
                "Short feeding windows (4\u20136 hours) may increase overeating, while 7\u20139 hour windows show consistent health benefits. ",
                "Fasting impacts brain and body, supporting clarity, hormone balance, and fat loss when coupled with caloric restriction."
            ],
            "connections": [
                "How does fasting affect hormones?",
                "The healthy hungry age better",
                "Hack your fuel",
                "Less (eating) is more (healthy)",
                "Stress on purpose"
            ],
            "url": "https://wellawarecare.substack.com/p/when-to-eat"
        },
        {
            "id": "Working workout",
            "tldr": [
                'Foundational health requires a mechanical mix of "Zone 2" aerobic work for mitochondrial density and "Vigorous" intervals for cardiovascular capacity (VO2 Max). Missing either node leaves the system without the structural overhead to manage metabolic stress or prevent physiological decay.'
            ],
            "connections": [
                "Brainiac strategies for the brain",
                "Get muscle mass.ive",
                "High performance sleeping",
                "Prevent that cancer",
                "Preventing Alzheimer\u2019s with lifestyle choices",
                "Stress on purpose",
                "Take 11 minutes a day to postpone death"
            ],
            "url": "https://wellawarecare.substack.com/p/working-workout"
        },
        {
            "id": "Y make a man",
            "tldr": [
                "The Y chromosome decides more than sex. It flips a switch before birth that tells the body to make testosterone, build testes, and wire the brain in a certain way. That early signal shapes how we move, think, and react long after we\u2019re born. Understanding what the Y does\u2014and what happens when its signal changes\u2014explains many of the real differences between male and female brains."
            ],
            "connections": [
                "Belly fat!",
                "Master of detox",
                "Detox with sleep"
            ],
            "url": "https://wellawarecare.substack.com/p/y-make-a-man"
        },
        {
            "id": "Your energy source",
            "tldr": [
                "Mitochondria are your body\u2019s energy producers, converting food and oxygen into ATP, the fuel for all cellular functions. ",
                "Damage to mitochondria, often caused by oxidative stress and environmental toxins, leads to fatigue, memory loss, and rapid aging. ",
                "Reducing sugar, processed foods, and toxins can protect mitochondria and enhance energy levels. ",
                "Exercise, especially interval training and strength training, along with antioxidant-rich plant foods, support mitochondrial health. ",
                "Key supplements like CoQ10, resveratrol, and omega-3s can further boost mitochondrial function and energy production."
            ],
            "connections": [
                "Explosive & toxic chemicals in food",
                "Functional medicine functioning",
                "Fruit juice to fatty liver",
                "Power up with potassium",
                "Ketogenic diet and cancer",
                "Take 11 minutes a day to postpone death",
                "The healthy hungry age better",
                "Be better than the conventional normal",
                "Faster weight loss on slow thyroid",
                "Supplements for your pretty face",
                "Supplementation is not expensive urine",
                "Zinc it up",
                "Fermented food benefits",
                "Insulin's hard problem",
                "Master of detox"
            ],
            "url": "https://wellawarecare.substack.com/p/your-energy-source"
        },
        {
            "id": "Zinc it up",
            "tldr": [
                "Zinc is essential for over 300 enzymatic reactions, impacting everything from hormones to skin health. ",
                "Zinc deficiency can manifest as digestive issues, mood changes, and low testosterone. ",
                "Supplementing with zinc and eating zinc-rich foods helps support cognitive function, hormone balance, and sleep. ",
                "Prioritize zinc to enhance your immune system, improve skin health, and boost overall well-being."
            ],
            "connections": [
                "Your energy source",
                "Be better than the conventional normal",
                "High performance sleeping",
                "Bread!",
                "Level up your gut!",
                "Power up with potassium",
                "Supplements for your pretty face",
                "Damn hard without vitamin D"
            ],
            "url": "https://wellawarecare.substack.com/p/zinc-it-up"
        }
    ],
    "links": [
        {
            "source": "Addiction friction",
            "target": "Sweet and salty sugar"
        },
        {
            "source": "Addiction friction",
            "target": "Unmanned man"
        },
        {
            "source": "Addiction friction",
            "target": "Out of focus"
        },
        {
            "source": "Addiction friction",
            "target": "Brain health 101"
        },
        {
            "source": "Addiction friction",
            "target": "Brainiac strategies for the brain"
        },
        {
            "source": "Addiction friction",
            "target": "Mind at volume"
        },
        {
            "source": "Addiction friction",
            "target": "Socialized wellness"
        },
        {
            "source": "Alcohol & DNA",
            "target": "Level up your gut!"
        },
        {
            "source": "Alcohol & DNA",
            "target": "Non-food foods"
        },
        {
            "source": "Alcohol & DNA",
            "target": "The genetic disconnect"
        },
        {
            "source": "Alcohol & DNA",
            "target": "Prevent that cancer"
        },
        {
            "source": "Alcohol & DNA",
            "target": "Fermented food benefits"
        },
        {
            "source": "Alcohol & DNA",
            "target": "Supplementation is not expensive urine"
        },
        {
            "source": "Alcohol & DNA",
            "target": "Hack your fuel"
        },
        {
            "source": "Alcohol & DNA",
            "target": "Hangovers"
        },
        {
            "source": "Alcohol & DNA",
            "target": "When alcohol hits the cells"
        },
        {
            "source": "Alcohol & DNA",
            "target": "Blackouts"
        },
        {
            "source": "Be better than the conventional normal",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Be better than the conventional normal",
            "target": "Power up with potassium"
        },
        {
            "source": "Be better than the conventional normal",
            "target": "High performance sleeping"
        },
        {
            "source": "Be better than the conventional normal",
            "target": "Zinc it up"
        },
        {
            "source": "Belly fat!",
            "target": "Bread!"
        },
        {
            "source": "Belly fat!",
            "target": "One third of your youth"
        },
        {
            "source": "Belly fat!",
            "target": "High performance sleeping"
        },
        {
            "source": "Belly fat!",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "Belly fat!",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "Belly fat!",
            "target": "No sweet dreams with sweets"
        },
        {
            "source": "Blackouts",
            "target": "Brain health 101"
        },
        {
            "source": "Blackouts",
            "target": "When alcohol hits the cells"
        },
        {
            "source": "Blackouts",
            "target": "Alcohol & DNA"
        },
        {
            "source": "Bonds, alpha females & botox",
            "target": "Nasties in beauty"
        },
        {
            "source": "Brain health 101",
            "target": "Effects of mouth's proximity to the brain"
        },
        {
            "source": "Brain health 101",
            "target": "Welcome the suck"
        },
        {
            "source": "Brain health 101",
            "target": "Non-food foods"
        },
        {
            "source": "Brain health 101",
            "target": "High performance sleeping"
        },
        {
            "source": "Brain health 101",
            "target": "Power up with potassium"
        },
        {
            "source": "Brain health 101",
            "target": "Preventing Alzheimer\u2019s with lifestyle choices"
        },
        {
            "source": "Brain health 101",
            "target": "The healthy hungry age better"
        },
        {
            "source": "Brain health 101",
            "target": "Zinc it up"
        },
        {
            "source": "Brain health 101",
            "target": "Reorder mental disorder"
        },
        {
            "source": "Brain health 101",
            "target": "Sweet and salty sugar"
        },
        {
            "source": "Brain health 101",
            "target": "Detox with sleep"
        },
        {
            "source": "Brainiac strategies for the brain",
            "target": "Non-food foods"
        },
        {
            "source": "Brainiac strategies for the brain",
            "target": "The sugar consequences of salt"
        },
        {
            "source": "Brainiac strategies for the brain",
            "target": "Take 11 minutes a day to postpone death"
        },
        {
            "source": "Brainiac strategies for the brain",
            "target": "Sweet and salty sugar"
        },
        {
            "source": "Brainiac strategies for the brain",
            "target": "Insulin's hard problem"
        },
        {
            "source": "Brainiac strategies for the brain",
            "target": "Hold on to your strength"
        },
        {
            "source": "Bread!",
            "target": "The real spice, girl!"
        },
        {
            "source": "Bread!",
            "target": "Belly fat!"
        },
        {
            "source": "Bread!",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "Bread!",
            "target": "How do you like them apples?"
        },
        {
            "source": "Bread!",
            "target": "High performance sleeping"
        },
        {
            "source": "Can't lose weight?",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Can't lose weight?",
            "target": "The real spice, girl!"
        },
        {
            "source": "Can't lose weight?",
            "target": "Belly fat!"
        },
        {
            "source": "Can't lose weight?",
            "target": "Level up your gut!"
        },
        {
            "source": "Can't lose weight?",
            "target": "Fruit juice to fatty liver"
        },
        {
            "source": "Can't lose weight?",
            "target": "Faster weight loss on slow thyroid"
        },
        {
            "source": "Can't lose weight?",
            "target": "Nasties in beauty"
        },
        {
            "source": "Can't lose weight?",
            "target": "Hack your fuel"
        },
        {
            "source": "Can't lose weight?",
            "target": "Pick not Ozempic"
        },
        {
            "source": "Can't lose weight?",
            "target": "When to eat?"
        },
        {
            "source": "Can't lose weight?",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Comfy crash",
            "target": "Crave brain rave"
        },
        {
            "source": "Comfy crash",
            "target": "Hack your fuel"
        },
        {
            "source": "Comfy crash",
            "target": "Power up with potassium"
        },
        {
            "source": "Comfy crash",
            "target": "Preventing Alzheimer\u2019s with lifestyle choices"
        },
        {
            "source": "Comfy crash",
            "target": "Socialized wellness"
        },
        {
            "source": "Complexities of depression",
            "target": "Brain health 101"
        },
        {
            "source": "Complexities of depression",
            "target": "Non-food foods"
        },
        {
            "source": "Complexities of depression",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "Complexities of depression",
            "target": "Detox with sleep"
        },
        {
            "source": "Complexities of depression",
            "target": "Reorder mental disorder"
        },
        {
            "source": "Complexities of depression",
            "target": "Health we inherit"
        },
        {
            "source": "Crave brain rave",
            "target": "Your energy source"
        },
        {
            "source": "Crave brain rave",
            "target": "Non-food foods"
        },
        {
            "source": "Crave brain rave",
            "target": "Insulin's hard problem"
        },
        {
            "source": "Crave brain rave",
            "target": "Reorder mental disorder"
        },
        {
            "source": "Crave brain rave",
            "target": "Starve that cancer"
        },
        {
            "source": "Crave brain rave",
            "target": "Sweet and salty sugar"
        },
        {
            "source": "Crave brain rave",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Crave brain rave",
            "target": "Preventing Alzheimer\u2019s with lifestyle choices"
        },
        {
            "source": "Crystal clear pain",
            "target": "Forged in iron"
        },
        {
            "source": "Crystal clear pain",
            "target": "Joint pain"
        },
        {
            "source": "Crystal clear pain",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "Crystal clear pain",
            "target": "Level up your gut!"
        },
        {
            "source": "Damn hard without vitamin D",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Damn hard without vitamin D",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Damn hard without vitamin D",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Damn hard without vitamin D",
            "target": "Vitamin D Deficiency"
        },
        {
            "source": "Damn hard without vitamin D",
            "target": "Hold on to your strength"
        },
        {
            "source": "Detox with sleep",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Detox with sleep",
            "target": "High performance sleeping"
        },
        {
            "source": "Detox with sleep",
            "target": "Preventing Alzheimer\u2019s with lifestyle choices"
        },
        {
            "source": "Detox with sleep",
            "target": "Brain health 101"
        },
        {
            "source": "Don't de-health while deodorizing",
            "target": "Femme fatale fragrance"
        },
        {
            "source": "Don't de-health while deodorizing",
            "target": "Ketogenic diet and cancer"
        },
        {
            "source": "Don't de-health while deodorizing",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "Don't de-health while deodorizing",
            "target": "Nasties in beauty"
        },
        {
            "source": "Don't de-health while deodorizing",
            "target": "The genetic disconnect"
        },
        {
            "source": "Don't de-health while deodorizing",
            "target": "Starve that cancer"
        },
        {
            "source": "Eating electronics",
            "target": "Nasties in beauty"
        },
        {
            "source": "Eating electronics",
            "target": "The genetic disconnect"
        },
        {
            "source": "Eating electronics",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "Eating electronics",
            "target": "Is organic food worth it?"
        },
        {
            "source": "Effects of mouth's proximity to the brain",
            "target": "Non-food foods"
        },
        {
            "source": "Effects of mouth's proximity to the brain",
            "target": "Preventing Alzheimer\u2019s with lifestyle choices"
        },
        {
            "source": "Effects of mouth's proximity to the brain",
            "target": "Brain health 101"
        },
        {
            "source": "Effects of mouth's proximity to the brain",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "Effects of mouth's proximity to the brain",
            "target": "Nasties in beauty"
        },
        {
            "source": "Effects of mouth's proximity to the brain",
            "target": "Hold on to your strength"
        },
        {
            "source": "Effects of mouth's proximity to the brain",
            "target": "Detox with sleep"
        },
        {
            "source": "Explosive & toxic chemicals in food",
            "target": "Bread!"
        },
        {
            "source": "Explosive & toxic chemicals in food",
            "target": "Is organic food worth it?"
        },
        {
            "source": "Explosive & toxic chemicals in food",
            "target": "Level up your gut!"
        },
        {
            "source": "Explosive & toxic chemicals in food",
            "target": "Femme fatale fragrance"
        },
        {
            "source": "Explosive & toxic chemicals in food",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Explosive & toxic chemicals in food",
            "target": "Your energy source"
        },
        {
            "source": "Explosive & toxic chemicals in food",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "Faster weight loss on slow thyroid",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "Faster weight loss on slow thyroid",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Faster weight loss on slow thyroid",
            "target": "How do you like them apples?"
        },
        {
            "source": "Faster weight loss on slow thyroid",
            "target": "Level up your gut!"
        },
        {
            "source": "Faster weight loss on slow thyroid",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "Femme fatale fragrance",
            "target": "Don't de-health while deodorizing"
        },
        {
            "source": "Femme fatale fragrance",
            "target": "Nasties in beauty"
        },
        {
            "source": "Femme fatale fragrance",
            "target": "The genetic disconnect"
        },
        {
            "source": "Femme fatale fragrance",
            "target": "Master of detox"
        },
        {
            "source": "Fermented food benefits",
            "target": "The real spice, girl!"
        },
        {
            "source": "Fermented food benefits",
            "target": "Level up your gut!"
        },
        {
            "source": "Fermented food benefits",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Fermented food benefits",
            "target": "How do you like them apples?"
        },
        {
            "source": "Fermented food benefits",
            "target": "Non-food foods"
        },
        {
            "source": "Fermented food benefits",
            "target": "Supplementation is not expensive urine"
        },
        {
            "source": "Fermented food benefits",
            "target": "Hack your fuel"
        },
        {
            "source": "Filter with liver",
            "target": "Can't lose weight?"
        },
        {
            "source": "Filter with liver",
            "target": "When alcohol hits the cells"
        },
        {
            "source": "Filter with liver",
            "target": "Level up your gut!"
        },
        {
            "source": "Filter with liver",
            "target": "Inside job"
        },
        {
            "source": "Filter with liver",
            "target": "Rot is in the air"
        },
        {
            "source": "Filter with liver",
            "target": "Fruit juice to fatty liver"
        },
        {
            "source": "Filter with liver",
            "target": "One third of your youth"
        },
        {
            "source": "Filter with liver",
            "target": "The sugar consequences of salt"
        },
        {
            "source": "Filter with liver",
            "target": "When to eat?"
        },
        {
            "source": "Focus stacking",
            "target": "Filter with liver"
        },
        {
            "source": "Focus stacking",
            "target": "Level up your gut!"
        },
        {
            "source": "Focus stacking",
            "target": "Super sea food"
        },
        {
            "source": "Focus stacking",
            "target": "No sweet dreams with sweets"
        },
        {
            "source": "Forged in iron",
            "target": "Zinc it up"
        },
        {
            "source": "Fruit juice to fatty liver",
            "target": "The sugar consequences of salt"
        },
        {
            "source": "Fruit juice to fatty liver",
            "target": "One third of your youth"
        },
        {
            "source": "Fruit juice to fatty liver",
            "target": "Is organic food worth it?"
        },
        {
            "source": "Fruit juice to fatty liver",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "Fruit juice to fatty liver",
            "target": "When to eat?"
        },
        {
            "source": "Fruit juice to fatty liver",
            "target": "Starve that cancer"
        },
        {
            "source": "Fruit juice to fatty liver",
            "target": "Insulin's hard problem"
        },
        {
            "source": "Fruit juice to fatty liver",
            "target": "Can't lose weight?"
        },
        {
            "source": "Full of full fat",
            "target": "Alcohol & DNA"
        },
        {
            "source": "Full of full fat",
            "target": "Belly fat!"
        },
        {
            "source": "Full of full fat",
            "target": "Can't lose weight?"
        },
        {
            "source": "Full of full fat",
            "target": "Faster weight loss on slow thyroid"
        },
        {
            "source": "Full of full fat",
            "target": "Filter with liver"
        },
        {
            "source": "Full of full fat",
            "target": "Hack your fuel"
        },
        {
            "source": "Full of full fat",
            "target": "How do you like them apples?"
        },
        {
            "source": "Full of full fat",
            "target": "Is organic food worth it?"
        },
        {
            "source": "Full of full fat",
            "target": "The sugar consequences of salt"
        },
        {
            "source": "Full of full fat",
            "target": "When to eat?"
        },
        {
            "source": "Functional medicine functioning",
            "target": "Your energy source"
        },
        {
            "source": "Get muscle mass.ive",
            "target": "Meat (head) and iron (maiden)"
        },
        {
            "source": "Get muscle mass.ive",
            "target": "Hack your fuel"
        },
        {
            "source": "Get muscle mass.ive",
            "target": "Hold on to your strength"
        },
        {
            "source": "Get muscle mass.ive",
            "target": "Stress on purpose"
        },
        {
            "source": "Get muscle mass.ive",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Get muscle mass.ive",
            "target": "Power up with potassium"
        },
        {
            "source": "Get muscle mass.ive",
            "target": "Your energy source"
        },
        {
            "source": "Grit, Glucose & Grind",
            "target": "Hack your fuel"
        },
        {
            "source": "Grit, Glucose & Grind",
            "target": "Detox with sleep"
        },
        {
            "source": "Grit, Glucose & Grind",
            "target": "Get muscle mass.ive"
        },
        {
            "source": "Grit, Glucose & Grind",
            "target": "Stress on purpose"
        },
        {
            "source": "Hack your fuel",
            "target": "Your energy source"
        },
        {
            "source": "Hack your fuel",
            "target": "Power up with potassium"
        },
        {
            "source": "Hack your fuel",
            "target": "The healthy hungry age better"
        },
        {
            "source": "Hack your fuel",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "Hack your fuel",
            "target": "Stress on purpose"
        },
        {
            "source": "Hack your fuel",
            "target": "When to eat?"
        },
        {
            "source": "Hangovers",
            "target": "Power up with potassium"
        },
        {
            "source": "Hangovers",
            "target": "Level up your gut!"
        },
        {
            "source": "Hangovers",
            "target": "Supplementation is not expensive urine"
        },
        {
            "source": "Hangovers",
            "target": "Alcohol & DNA"
        },
        {
            "source": "Hangovers",
            "target": "Hack your fuel"
        },
        {
            "source": "Hangovers",
            "target": "Fermented food benefits"
        },
        {
            "source": "Hangovers",
            "target": "Inflammation to cancer"
        },
        {
            "source": "Hangovers",
            "target": "When alcohol hits the cells"
        },
        {
            "source": "Hangovers",
            "target": "Blackouts"
        },
        {
            "source": "Health we inherit",
            "target": "Your energy source"
        },
        {
            "source": "Health we inherit",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Health we inherit",
            "target": "The genetic disconnect"
        },
        {
            "source": "Health we inherit",
            "target": "Reorder mental disorder"
        },
        {
            "source": "Health we inherit",
            "target": "Brainiac strategies for the brain"
        },
        {
            "source": "High performance sleeping",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "High performance sleeping",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "High performance sleeping",
            "target": "One third of your youth"
        },
        {
            "source": "High performance sleeping",
            "target": "Detox with sleep"
        },
        {
            "source": "High performance sleeping",
            "target": "Hold on to your strength"
        },
        {
            "source": "High performance sleeping",
            "target": "No sweet dreams with sweets"
        },
        {
            "source": "High performance sleeping",
            "target": "Zinc it up"
        },
        {
            "source": "High performance sleeping",
            "target": "Brainiac strategies for the brain"
        },
        {
            "source": "Hold on to your strength",
            "target": "Power up with potassium"
        },
        {
            "source": "Hold on to your strength",
            "target": "Take 11 minutes a day to postpone death"
        },
        {
            "source": "Hold on to your strength",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Hold on to your strength",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "How do you like them apples?",
            "target": "Functional medicine functioning"
        },
        {
            "source": "How do you like them apples?",
            "target": "Level up your gut!"
        },
        {
            "source": "How do you like them apples?",
            "target": "Belly fat!"
        },
        {
            "source": "How do you like them apples?",
            "target": "The healthy hungry age better"
        },
        {
            "source": "How do you like them apples?",
            "target": "Hack your fuel"
        },
        {
            "source": "How does fasting affect hormones?",
            "target": "The healthy hungry age better"
        },
        {
            "source": "How does fasting affect hormones?",
            "target": "High performance sleeping"
        },
        {
            "source": "How does fasting affect hormones?",
            "target": "Faster weight loss on slow thyroid"
        },
        {
            "source": "How does fasting affect hormones?",
            "target": "Zinc it up"
        },
        {
            "source": "How does fasting affect hormones?",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "How does fasting affect hormones?",
            "target": "Insulin's hard problem"
        },
        {
            "source": "How does fasting affect hormones?",
            "target": "Hack your fuel"
        },
        {
            "source": "How does fasting affect hormones?",
            "target": "Detox with sleep"
        },
        {
            "source": "Inflammation to cancer",
            "target": "Your energy source"
        },
        {
            "source": "Inflammation to cancer",
            "target": "Ketogenic diet and cancer"
        },
        {
            "source": "Inflammation to cancer",
            "target": "Non-food foods"
        },
        {
            "source": "Inflammation to cancer",
            "target": "Prevent that cancer"
        },
        {
            "source": "Inflammation to cancer",
            "target": "Starve that cancer"
        },
        {
            "source": "Inflammation to cancer",
            "target": "The genetic disconnect"
        },
        {
            "source": "Input equals IQ",
            "target": "Forged in iron"
        },
        {
            "source": "Input equals IQ",
            "target": "Hack your fuel"
        },
        {
            "source": "Input equals IQ",
            "target": "Brain health 101"
        },
        {
            "source": "Input equals IQ",
            "target": "Brainiac strategies for the brain"
        },
        {
            "source": "Input equals IQ",
            "target": "Detox with sleep"
        },
        {
            "source": "Input equals IQ",
            "target": "Preventing Alzheimer\u2019s with lifestyle choices"
        },
        {
            "source": "Inside job",
            "target": "Fermented food benefits"
        },
        {
            "source": "Inside job",
            "target": "How do you like them apples?"
        },
        {
            "source": "Inside job",
            "target": "Level up your gut!"
        },
        {
            "source": "Inside job",
            "target": "Non-food foods"
        },
        {
            "source": "Insulin's hard problem",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "Insulin's hard problem",
            "target": "One third of your youth"
        },
        {
            "source": "Insulin's hard problem",
            "target": "The sugar consequences of salt"
        },
        {
            "source": "Insulin's hard problem",
            "target": "Faster weight loss on slow thyroid"
        },
        {
            "source": "Insulin's hard problem",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "Insulin's hard problem",
            "target": "Hack your fuel"
        },
        {
            "source": "Insulin's hard problem",
            "target": "Stress on purpose"
        },
        {
            "source": "Is organic food worth it?",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Is organic food worth it?",
            "target": "Level up your gut!"
        },
        {
            "source": "Is organic food worth it?",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Is organic food worth it?",
            "target": "Your energy source"
        },
        {
            "source": "Is organic food worth it?",
            "target": "Non-food foods"
        },
        {
            "source": "Joint pain",
            "target": "Insulin's hard problem"
        },
        {
            "source": "Joint pain",
            "target": "Detox with sleep"
        },
        {
            "source": "Joint pain",
            "target": "Hack your fuel"
        },
        {
            "source": "Joint pain",
            "target": "Level up your gut!"
        },
        {
            "source": "Joint pain",
            "target": "How do you like them apples?"
        },
        {
            "source": "Joint pain",
            "target": "Comfy crash"
        },
        {
            "source": "Joint pain",
            "target": "The real spice, girl!"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "The real spice, girl!"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "Preventing Alzheimer\u2019s with lifestyle choices"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "Take 11 minutes a day to postpone death"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "The healthy hungry age better"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "Your energy source"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "Starve that cancer"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "Prevent that cancer"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "Inflammation to cancer"
        },
        {
            "source": "Ketogenic diet and cancer",
            "target": "Detox with sleep"
        },
        {
            "source": "Lactose in-tolerance?",
            "target": "Level up your gut!"
        },
        {
            "source": "Lactose in-tolerance?",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Lactose in-tolerance?",
            "target": "Vitamin D Deficiency"
        },
        {
            "source": "Lactose in-tolerance?",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "Lean mean double green",
            "target": "Your energy source"
        },
        {
            "source": "Lean mean double green",
            "target": "Non-food foods"
        },
        {
            "source": "Lean mean double green",
            "target": "Master of detox"
        },
        {
            "source": "Lean mean double green",
            "target": "One third of your youth"
        },
        {
            "source": "Less (eating) is more (healthy)",
            "target": "Faster weight loss on slow thyroid"
        },
        {
            "source": "Less (eating) is more (healthy)",
            "target": "The healthy hungry age better"
        },
        {
            "source": "Less (eating) is more (healthy)",
            "target": "Your energy source"
        },
        {
            "source": "Less (eating) is more (healthy)",
            "target": "Belly fat!"
        },
        {
            "source": "Less (eating) is more (healthy)",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "Less (eating) is more (healthy)",
            "target": "Level up your gut!"
        },
        {
            "source": "Less (eating) is more (healthy)",
            "target": "Prevent that cancer"
        },
        {
            "source": "Less (eating) is more (healthy)",
            "target": "Starve that cancer"
        },
        {
            "source": "Level up your gut!",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Level up your gut!",
            "target": "Level up your gut!"
        },
        {
            "source": "Level up your gut!",
            "target": "Bread!"
        },
        {
            "source": "Level up your gut!",
            "target": "Is organic food worth it?"
        },
        {
            "source": "Level up your gut!",
            "target": "Non-food foods"
        },
        {
            "source": "Level up your gut!",
            "target": "Lactose in-tolerance?"
        },
        {
            "source": "Level up your gut!",
            "target": "Fermented food benefits"
        },
        {
            "source": "Level up your gut!",
            "target": "Supplementation is not expensive urine"
        },
        {
            "source": "Life lemon duo",
            "target": "Mind at volume"
        },
        {
            "source": "Life lemon duo",
            "target": "Health we inherit"
        },
        {
            "source": "Life lemon duo",
            "target": "Reorder mental disorder"
        },
        {
            "source": "Life lemon duo",
            "target": "Right brain is right"
        },
        {
            "source": "Life lemon duo",
            "target": "Complexities of depression"
        },
        {
            "source": "Master of detox",
            "target": "Supplements for your pretty face"
        },
        {
            "source": "Master of detox",
            "target": "Femme fatale fragrance"
        },
        {
            "source": "Master of detox",
            "target": "Don't de-health while deodorizing"
        },
        {
            "source": "Master of detox",
            "target": "Nasties in beauty"
        },
        {
            "source": "Master of detox",
            "target": "The genetic disconnect"
        },
        {
            "source": "Master of detox",
            "target": "Zinc it up"
        },
        {
            "source": "Meat (head) and iron (maiden)",
            "target": "Hack your fuel"
        },
        {
            "source": "Meat (head) and iron (maiden)",
            "target": "Is organic food worth it?"
        },
        {
            "source": "Meat (head) and iron (maiden)",
            "target": "Lactose in-tolerance?"
        },
        {
            "source": "Meat (head) and iron (maiden)",
            "target": "Pick not Ozempic"
        },
        {
            "source": "Mind at volume",
            "target": "Life lemon duo"
        },
        {
            "source": "Mind at volume",
            "target": "Brain health 101"
        },
        {
            "source": "Nasties in beauty",
            "target": "Femme fatale fragrance"
        },
        {
            "source": "Nasties in beauty",
            "target": "Bonds, alpha females & botox"
        },
        {
            "source": "Nasties in beauty",
            "target": "The real spice, girl!"
        },
        {
            "source": "Nasties in beauty",
            "target": "The genetic disconnect"
        },
        {
            "source": "No sweet dreams with sweets",
            "target": "High performance sleeping"
        },
        {
            "source": "No sweet dreams with sweets",
            "target": "Non-food foods"
        },
        {
            "source": "No sweet dreams with sweets",
            "target": "The sugar consequences of salt"
        },
        {
            "source": "No sweet dreams with sweets",
            "target": "Detox with sleep"
        },
        {
            "source": "No sweet dreams with sweets",
            "target": "Sweet and salty sugar"
        },
        {
            "source": "Non-food foods",
            "target": "The sugar consequences of salt"
        },
        {
            "source": "Non-food foods",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Non-food foods",
            "target": "Is organic food worth it?"
        },
        {
            "source": "Non-food foods",
            "target": "Level up your gut!"
        },
        {
            "source": "Non-food foods",
            "target": "Brain health 101"
        },
        {
            "source": "Non-food foods",
            "target": "Your energy source"
        },
        {
            "source": "Non-food foods",
            "target": "Power up with potassium"
        },
        {
            "source": "Non-food foods",
            "target": "Prevent that cancer"
        },
        {
            "source": "Non-food foods",
            "target": "Starve that cancer"
        },
        {
            "source": "One third of your youth",
            "target": "Your energy source"
        },
        {
            "source": "One third of your youth",
            "target": "Supplements for your pretty face"
        },
        {
            "source": "One third of your youth",
            "target": "Level up your gut!"
        },
        {
            "source": "One third of your youth",
            "target": "High performance sleeping"
        },
        {
            "source": "One third of your youth",
            "target": "Fermented food benefits"
        },
        {
            "source": "One third of your youth",
            "target": "The genetic disconnect"
        },
        {
            "source": "One third of your youth",
            "target": "Hack your fuel"
        },
        {
            "source": "One third of your youth",
            "target": "Master of detox"
        },
        {
            "source": "One third of your youth",
            "target": "Detox with sleep"
        },
        {
            "source": "Out of focus",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "Out of focus",
            "target": "Inside job"
        },
        {
            "source": "Peaked at 25",
            "target": "Working workout"
        },
        {
            "source": "Peaked at 25",
            "target": "Get muscle mass.ive"
        },
        {
            "source": "Peaked at 25",
            "target": "Power powder"
        },
        {
            "source": "Peaked at 25",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Peaked at 25",
            "target": "Hack your fuel"
        },
        {
            "source": "Peaked at 25",
            "target": "Stress on purpose"
        },
        {
            "source": "Pick not Ozempic",
            "target": "Your energy source"
        },
        {
            "source": "Pick not Ozempic",
            "target": "Hold on to your strength"
        },
        {
            "source": "Power powder",
            "target": "Get muscle mass.ive"
        },
        {
            "source": "Power powder",
            "target": "Hold on to your strength"
        },
        {
            "source": "Power up with potassium",
            "target": "Your energy source"
        },
        {
            "source": "Power up with potassium",
            "target": "Supplements for your pretty face"
        },
        {
            "source": "Power up with potassium",
            "target": "Zinc it up"
        },
        {
            "source": "Power up with potassium",
            "target": "When alcohol hits the cells"
        },
        {
            "source": "Power up with potassium",
            "target": "Hack your fuel"
        },
        {
            "source": "Power up with potassium",
            "target": "Hangovers"
        },
        {
            "source": "Power up with potassium",
            "target": "Hold on to your strength"
        },
        {
            "source": "Power up with potassium",
            "target": "Stress on purpose"
        },
        {
            "source": "Power up with potassium",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "Prevent that cancer",
            "target": "Ketogenic diet and cancer"
        },
        {
            "source": "Prevent that cancer",
            "target": "Non-food foods"
        },
        {
            "source": "Prevent that cancer",
            "target": "Take 11 minutes a day to postpone death"
        },
        {
            "source": "Prevent that cancer",
            "target": "The healthy hungry age better"
        },
        {
            "source": "Prevent that cancer",
            "target": "Don't de-health while deodorizing"
        },
        {
            "source": "Prevent that cancer",
            "target": "The real spice, girl!"
        },
        {
            "source": "Prevent that cancer",
            "target": "Nasties in beauty"
        },
        {
            "source": "Prevent that cancer",
            "target": "Alcohol & DNA"
        },
        {
            "source": "Prevent that cancer",
            "target": "Inflammation to cancer"
        },
        {
            "source": "Prevent that cancer",
            "target": "Starve that cancer"
        },
        {
            "source": "Prevent that cancer",
            "target": "Can't lose weight?"
        },
        {
            "source": "Prevent that cancer",
            "target": "Health we inherit"
        },
        {
            "source": "Preventing Alzheimer\u2019s with lifestyle choices",
            "target": "Brain health 101"
        },
        {
            "source": "Preventing Alzheimer\u2019s with lifestyle choices",
            "target": "Effects of mouth's proximity to the brain"
        },
        {
            "source": "Preventing Alzheimer\u2019s with lifestyle choices",
            "target": "Non-food foods"
        },
        {
            "source": "Preventing Alzheimer\u2019s with lifestyle choices",
            "target": "Hold on to your strength"
        },
        {
            "source": "Preventing Alzheimer\u2019s with lifestyle choices",
            "target": "Detox with sleep"
        },
        {
            "source": "Preventing Alzheimer\u2019s with lifestyle choices",
            "target": "Brainiac strategies for the brain"
        },
        {
            "source": "Preventing Alzheimer\u2019s with lifestyle choices",
            "target": "Reorder mental disorder"
        },
        {
            "source": "Preventing Alzheimer\u2019s with lifestyle choices",
            "target": "Insulin's hard problem"
        },
        {
            "source": "Push against gravity",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Push against gravity",
            "target": "Get muscle mass.ive"
        },
        {
            "source": "Push against gravity",
            "target": "Hack your fuel"
        },
        {
            "source": "Push against gravity",
            "target": "Hold on to your strength"
        },
        {
            "source": "Quiet Fire",
            "target": "Hack your fuel"
        },
        {
            "source": "Quiet Fire",
            "target": "Inflammation to cancer"
        },
        {
            "source": "Quiet Fire",
            "target": "Inside job"
        },
        {
            "source": "Quiet Fire",
            "target": "Joint pain"
        },
        {
            "source": "Quiet Fire",
            "target": "Ketogenic diet and cancer"
        },
        {
            "source": "Quiet Fire",
            "target": "Lactose in-tolerance?"
        },
        {
            "source": "Quiet Fire",
            "target": "Lean mean double green"
        },
        {
            "source": "Quiet Fire",
            "target": "Meat (head) and iron (maiden)"
        },
        {
            "source": "Quiet Fire",
            "target": "Non-food foods"
        },
        {
            "source": "Quiet Fire",
            "target": "Prevent that cancer"
        },
        {
            "source": "Reorder mental disorder",
            "target": "Brain health 101"
        },
        {
            "source": "Reorder mental disorder",
            "target": "Effects of mouth's proximity to the brain"
        },
        {
            "source": "Reorder mental disorder",
            "target": "Welcome the suck"
        },
        {
            "source": "Reorder mental disorder",
            "target": "Detox with sleep"
        },
        {
            "source": "Reorder mental disorder",
            "target": "Fermented food benefits"
        },
        {
            "source": "Reorder mental disorder",
            "target": "Brainiac strategies for the brain"
        },
        {
            "source": "Reorder mental disorder",
            "target": "Complexities of depression"
        },
        {
            "source": "Reorder mental disorder",
            "target": "Health we inherit"
        },
        {
            "source": "Right brain is right",
            "target": "Socialized wellness"
        },
        {
            "source": "Right brain is right",
            "target": "Brainiac strategies for the brain"
        },
        {
            "source": "Right brain is right",
            "target": "Reorder mental disorder"
        },
        {
            "source": "Rot is in the air",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Rot is in the air",
            "target": "Don't de-health while deodorizing"
        },
        {
            "source": "Rot is in the air",
            "target": "Master of detox"
        },
        {
            "source": "Smell it out",
            "target": "Bonds, alpha females & botox"
        },
        {
            "source": "Socialized wellness",
            "target": "Smell it out"
        },
        {
            "source": "Socialized wellness",
            "target": "Bonds, alpha females & botox"
        },
        {
            "source": "Socialized wellness",
            "target": "Brain health 101"
        },
        {
            "source": "Spermi got nerdy",
            "target": "Master of detox"
        },
        {
            "source": "Spermi got nerdy",
            "target": "Level up your gut!"
        },
        {
            "source": "Spermi got nerdy",
            "target": "One third of your youth"
        },
        {
            "source": "Spermi got nerdy",
            "target": "Supplements for your pretty face"
        },
        {
            "source": "Spermi got nerdy",
            "target": "Your energy source"
        },
        {
            "source": "Starve that cancer",
            "target": "Ketogenic diet and cancer"
        },
        {
            "source": "Starve that cancer",
            "target": "Non-food foods"
        },
        {
            "source": "Starve that cancer",
            "target": "Take 11 minutes a day to postpone death"
        },
        {
            "source": "Starve that cancer",
            "target": "The healthy hungry age better"
        },
        {
            "source": "Starve that cancer",
            "target": "Don't de-health while deodorizing"
        },
        {
            "source": "Starve that cancer",
            "target": "The real spice, girl!"
        },
        {
            "source": "Starve that cancer",
            "target": "Inflammation to cancer"
        },
        {
            "source": "Starve that cancer",
            "target": "Nasties in beauty"
        },
        {
            "source": "Starve that cancer",
            "target": "Prevent that cancer"
        },
        {
            "source": "Starve that cancer",
            "target": "Alcohol & DNA"
        },
        {
            "source": "Starve that cancer",
            "target": "Can't lose weight?"
        },
        {
            "source": "Starve that cancer",
            "target": "Health we inherit"
        },
        {
            "source": "Stress on purpose",
            "target": "Your energy source"
        },
        {
            "source": "Stress on purpose",
            "target": "Hold on to your strength"
        },
        {
            "source": "Stress on purpose",
            "target": "High performance sleeping"
        },
        {
            "source": "Super sea food",
            "target": "Lean mean double green"
        },
        {
            "source": "Supplementation is not expensive urine",
            "target": "Power up with potassium"
        },
        {
            "source": "Supplementation is not expensive urine",
            "target": "Supplements for your pretty face"
        },
        {
            "source": "Supplementation is not expensive urine",
            "target": "Brain health 101"
        },
        {
            "source": "Supplementation is not expensive urine",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "Supplementation is not expensive urine",
            "target": "Vitamin D Deficiency"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "One third of your youth"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Don't de-health while deodorizing"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Bonds, alpha females & botox"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Your energy source"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Femme fatale fragrance"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Nasties in beauty"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Master of detox"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Supplementation is not expensive urine"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Lactose in-tolerance?"
        },
        {
            "source": "Supplements for your pretty face",
            "target": "Zinc it up"
        },
        {
            "source": "Sweet and salty sugar",
            "target": "Non-food foods"
        },
        {
            "source": "Sweet and salty sugar",
            "target": "Your energy source"
        },
        {
            "source": "Sweet and salty sugar",
            "target": "Fruit juice to fatty liver"
        },
        {
            "source": "Sweet and salty sugar",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Sweet and salty sugar",
            "target": "Starve that cancer"
        },
        {
            "source": "Sweet and salty sugar",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "Sweet and salty sugar",
            "target": "No sweet dreams with sweets"
        },
        {
            "source": "Take 11 minutes a day to postpone death",
            "target": "Your energy source"
        },
        {
            "source": "Take 11 minutes a day to postpone death",
            "target": "Hold on to your strength"
        },
        {
            "source": "The dark light",
            "target": "Out of focus"
        },
        {
            "source": "The dark light",
            "target": "Vitamin D Deficiency"
        },
        {
            "source": "The genetic disconnect",
            "target": "Preventing Alzheimer\u2019s with lifestyle choices"
        },
        {
            "source": "The genetic disconnect",
            "target": "Femme fatale fragrance"
        },
        {
            "source": "The genetic disconnect",
            "target": "Brain health 101"
        },
        {
            "source": "The genetic disconnect",
            "target": "Insulin's hard problem"
        },
        {
            "source": "The genetic disconnect",
            "target": "Inflammation to cancer"
        },
        {
            "source": "The genetic disconnect",
            "target": "Nasties in beauty"
        },
        {
            "source": "The healthy hungry age better",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "The healthy hungry age better",
            "target": "Brain health 101"
        },
        {
            "source": "The healthy hungry age better",
            "target": "Your energy source"
        },
        {
            "source": "The healthy hungry age better",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "The healthy hungry age better",
            "target": "Faster weight loss on slow thyroid"
        },
        {
            "source": "The healthy hungry age better",
            "target": "When to eat?"
        },
        {
            "source": "The healthy hungry age better",
            "target": "Hack your fuel"
        },
        {
            "source": "The real spice, girl!",
            "target": "Brain health 101"
        },
        {
            "source": "The real spice, girl!",
            "target": "Level up your gut!"
        },
        {
            "source": "The real spice, girl!",
            "target": "Prevent that cancer"
        },
        {
            "source": "The real spice, girl!",
            "target": "Inflammation to cancer"
        },
        {
            "source": "The real spice, girl!",
            "target": "Hack your fuel"
        },
        {
            "source": "The sugar consequences of salt",
            "target": "Your energy source"
        },
        {
            "source": "The sugar consequences of salt",
            "target": "Fruit juice to fatty liver"
        },
        {
            "source": "The sugar consequences of salt",
            "target": "One third of your youth"
        },
        {
            "source": "The sugar consequences of salt",
            "target": "Non-food foods"
        },
        {
            "source": "The sugar consequences of salt",
            "target": "Starve that cancer"
        },
        {
            "source": "The sugar consequences of salt",
            "target": "Hold on to your strength"
        },
        {
            "source": "Toxic traditions",
            "target": "Effects of mouth's proximity to the brain"
        },
        {
            "source": "Toxic traditions",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Toxic traditions",
            "target": "Femme fatale fragrance"
        },
        {
            "source": "Toxic traditions",
            "target": "Lean mean double green"
        },
        {
            "source": "Toxic traditions",
            "target": "Master of detox"
        },
        {
            "source": "Toxic traditions",
            "target": "Rot is in the air"
        },
        {
            "source": "Toxic traditions",
            "target": "Don't de-health while deodorizing"
        },
        {
            "source": "Unmanned man",
            "target": "Grit, Glucose & Grind"
        },
        {
            "source": "Unmanned man",
            "target": "Socialized wellness"
        },
        {
            "source": "Unmanned man",
            "target": "Y make a man"
        },
        {
            "source": "Unmanned man",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Unmanned man",
            "target": "Welcome the suck"
        },
        {
            "source": "Vampire queen",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Vampire queen",
            "target": "Master of detox"
        },
        {
            "source": "Vampire queen",
            "target": "Supplements for your pretty face"
        },
        {
            "source": "Vitamin D Deficiency",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Vitamin D Deficiency",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Vitamin D Deficiency",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Vitamin D Deficiency",
            "target": "Supplementation is not expensive urine"
        },
        {
            "source": "Vitamin D Deficiency",
            "target": "Nasties in beauty"
        },
        {
            "source": "Vitamin D Deficiency",
            "target": "Hold on to your strength"
        },
        {
            "source": "Vitamin D Deficiency",
            "target": "Damn hard without vitamin D"
        },
        {
            "source": "Welcome the suck",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "Welcome the suck",
            "target": "Reorder mental disorder"
        },
        {
            "source": "When alcohol hits the cells",
            "target": "Brain health 101"
        },
        {
            "source": "When alcohol hits the cells",
            "target": "Alcohol & DNA"
        },
        {
            "source": "When alcohol hits the cells",
            "target": "Blackouts"
        },
        {
            "source": "When alcohol hits the cells",
            "target": "Hangovers"
        },
        {
            "source": "When alcohol hits the cells",
            "target": "Brainiac strategies for the brain"
        },
        {
            "source": "When to eat?",
            "target": "How does fasting affect hormones?"
        },
        {
            "source": "When to eat?",
            "target": "The healthy hungry age better"
        },
        {
            "source": "When to eat?",
            "target": "Hack your fuel"
        },
        {
            "source": "When to eat?",
            "target": "Less (eating) is more (healthy)"
        },
        {
            "source": "When to eat?",
            "target": "Stress on purpose"
        },
        {
            "source": "Working workout",
            "target": "Brainiac strategies for the brain"
        },
        {
            "source": "Working workout",
            "target": "Get muscle mass.ive"
        },
        {
            "source": "Working workout",
            "target": "High performance sleeping"
        },
        {
            "source": "Working workout",
            "target": "Prevent that cancer"
        },
        {
            "source": "Working workout",
            "target": "Preventing Alzheimer\u2019s with lifestyle choices"
        },
        {
            "source": "Working workout",
            "target": "Stress on purpose"
        },
        {
            "source": "Working workout",
            "target": "Take 11 minutes a day to postpone death"
        },
        {
            "source": "Y make a man",
            "target": "Belly fat!"
        },
        {
            "source": "Y make a man",
            "target": "Master of detox"
        },
        {
            "source": "Y make a man",
            "target": "Detox with sleep"
        },
        {
            "source": "Your energy source",
            "target": "Explosive & toxic chemicals in food"
        },
        {
            "source": "Your energy source",
            "target": "Functional medicine functioning"
        },
        {
            "source": "Your energy source",
            "target": "Fruit juice to fatty liver"
        },
        {
            "source": "Your energy source",
            "target": "Power up with potassium"
        },
        {
            "source": "Your energy source",
            "target": "Ketogenic diet and cancer"
        },
        {
            "source": "Your energy source",
            "target": "Take 11 minutes a day to postpone death"
        },
        {
            "source": "Your energy source",
            "target": "The healthy hungry age better"
        },
        {
            "source": "Your energy source",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Your energy source",
            "target": "Faster weight loss on slow thyroid"
        },
        {
            "source": "Your energy source",
            "target": "Supplements for your pretty face"
        },
        {
            "source": "Your energy source",
            "target": "Supplementation is not expensive urine"
        },
        {
            "source": "Your energy source",
            "target": "Zinc it up"
        },
        {
            "source": "Your energy source",
            "target": "Fermented food benefits"
        },
        {
            "source": "Your energy source",
            "target": "Insulin's hard problem"
        },
        {
            "source": "Your energy source",
            "target": "Master of detox"
        },
        {
            "source": "Zinc it up",
            "target": "Your energy source"
        },
        {
            "source": "Zinc it up",
            "target": "Be better than the conventional normal"
        },
        {
            "source": "Zinc it up",
            "target": "High performance sleeping"
        },
        {
            "source": "Zinc it up",
            "target": "Bread!"
        },
        {
            "source": "Zinc it up",
            "target": "Level up your gut!"
        },
        {
            "source": "Zinc it up",
            "target": "Power up with potassium"
        },
        {
            "source": "Zinc it up",
            "target": "Supplements for your pretty face"
        },
        {
            "source": "Zinc it up",
            "target": "Damn hard without vitamin D"
        }
    ]
};




var $7c4cf709d1826294$var$noop = {
    value: ()=>{}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;



function $6e0da2549057218e$var$none() {}
function $6e0da2549057218e$export$2e2bcd8739ae039(selector) {
    return selector == null ? $6e0da2549057218e$var$none : function() {
        return this.querySelector(selector);
    };
}


function $31121acbef1e6956$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $cade2308c136039a$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}


function $7d92e4f75dbef49d$var$empty() {
    return [];
}
function $7d92e4f75dbef49d$export$2e2bcd8739ae039(selector) {
    return selector == null ? $7d92e4f75dbef49d$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}


function $a3d7edd03ec30cc1$var$arrayAll(select) {
    return function() {
        return (0, $cade2308c136039a$export$2e2bcd8739ae039)(select.apply(this, arguments));
    };
}
function $a3d7edd03ec30cc1$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $a3d7edd03ec30cc1$var$arrayAll(select);
    else select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, parents);
}


function $5fb24786d2a5f87a$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $5fb24786d2a5f87a$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}


var $31ffd623f27a3a65$var$find = Array.prototype.find;
function $31ffd623f27a3a65$var$childFind(match) {
    return function() {
        return $31ffd623f27a3a65$var$find.call(this.children, match);
    };
}
function $31ffd623f27a3a65$var$childFirst() {
    return this.firstElementChild;
}
function $31ffd623f27a3a65$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $31ffd623f27a3a65$var$childFirst : $31ffd623f27a3a65$var$childFind(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}



var $956143cec557381d$var$filter = Array.prototype.filter;
function $956143cec557381d$var$children() {
    return Array.from(this.children);
}
function $956143cec557381d$var$childrenFilter(match) {
    return function() {
        return $956143cec557381d$var$filter.call(this.children, match);
    };
}
function $956143cec557381d$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $956143cec557381d$var$children : $956143cec557381d$var$childrenFilter(typeof match === "function" ? match : (0, $5fb24786d2a5f87a$export$90c2759c036528)(match)));
}




function $ebbd333b038c2847$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(subgroups, this._parents);
}



function $e7fb628d3a97a780$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}



function $3e99928b06782938$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._enter || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}
function $3e99928b06782938$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$3e99928b06782938$export$67b01759a14cf6a4.prototype = {
    constructor: $3e99928b06782938$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};


function $d8d677a8510c2e55$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $cf943aeeeea8dffb$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $cf943aeeeea8dffb$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $3e99928b06782938$export$67b01759a14cf6a4)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $cf943aeeeea8dffb$var$datum(node) {
    return node.__data__;
}
function $cf943aeeeea8dffb$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $cf943aeeeea8dffb$var$datum);
    var bind = key ? $cf943aeeeea8dffb$var$bindKey : $cf943aeeeea8dffb$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $d8d677a8510c2e55$export$2e2bcd8739ae039)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $cf943aeeeea8dffb$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $cf943aeeeea8dffb$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}





function $69a673ff94b874e4$export$2e2bcd8739ae039() {
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(this._exit || this._groups.map((0, $e7fb628d3a97a780$export$2e2bcd8739ae039)), this._parents);
}


function $80f6488751784891$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}



function $63bab9b342eb32db$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(merges, this._parents);
}


function $7a935994b7a1f6cf$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}



function $faed8eab1469f61d$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $faed8eab1469f61d$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)(sortgroups, this._parents).order();
}
function $faed8eab1469f61d$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}


function $fa7212ea177e0f60$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}


function $c2d66609f799a53b$export$2e2bcd8739ae039() {
    return Array.from(this);
}


function $cb2fe8996a284614$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}


function $8d2a1d37edc5fc51$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}


function $3ed6ae19ad0a17a6$export$2e2bcd8739ae039() {
    return !this.node();
}


function $4a407aa055eb21e9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}


var $53f2bc3e7847f93d$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $53f2bc3e7847f93d$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $53f2bc3e7847f93d$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};


function $b659c67af9335162$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039).hasOwnProperty(prefix) ? {
        space: (0, $53f2bc3e7847f93d$export$2e2bcd8739ae039)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}


function $8ba31651ad7591ba$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $8ba31651ad7591ba$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $8ba31651ad7591ba$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $8ba31651ad7591ba$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $8ba31651ad7591ba$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $8ba31651ad7591ba$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $8ba31651ad7591ba$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $8ba31651ad7591ba$var$attrRemoveNS : $8ba31651ad7591ba$var$attrRemove : typeof value === "function" ? fullname.local ? $8ba31651ad7591ba$var$attrFunctionNS : $8ba31651ad7591ba$var$attrFunction : fullname.local ? $8ba31651ad7591ba$var$attrConstantNS : $8ba31651ad7591ba$var$attrConstant)(fullname, value));
}


function $89f2562a5a0d5a13$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}


function $6abb942964e997ae$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $6abb942964e997ae$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $6abb942964e997ae$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $6abb942964e997ae$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $6abb942964e997ae$var$styleRemove : typeof value === "function" ? $6abb942964e997ae$var$styleFunction : $6abb942964e997ae$var$styleConstant)(name, value, priority == null ? "" : priority)) : $6abb942964e997ae$export$5e3cec964f0b5efd(this.node(), name);
}
function $6abb942964e997ae$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node).getComputedStyle(node, null).getPropertyValue(name);
}


function $2b37810bbc11c28b$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $2b37810bbc11c28b$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $2b37810bbc11c28b$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $2b37810bbc11c28b$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $2b37810bbc11c28b$var$propertyRemove : typeof value === "function" ? $2b37810bbc11c28b$var$propertyFunction : $2b37810bbc11c28b$var$propertyConstant)(name, value)) : this.node()[name];
}


function $6515c3ccac9efd7a$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $6515c3ccac9efd7a$var$classList(node) {
    return node.classList || new $6515c3ccac9efd7a$var$ClassList(node);
}
function $6515c3ccac9efd7a$var$ClassList(node) {
    this._node = node;
    this._names = $6515c3ccac9efd7a$var$classArray(node.getAttribute("class") || "");
}
$6515c3ccac9efd7a$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $6515c3ccac9efd7a$var$classedAdd(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $6515c3ccac9efd7a$var$classedRemove(node, names) {
    var list = $6515c3ccac9efd7a$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $6515c3ccac9efd7a$var$classedTrue(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedAdd(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFalse(names) {
    return function() {
        $6515c3ccac9efd7a$var$classedRemove(this, names);
    };
}
function $6515c3ccac9efd7a$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $6515c3ccac9efd7a$var$classedAdd : $6515c3ccac9efd7a$var$classedRemove)(this, names);
    };
}
function $6515c3ccac9efd7a$export$2e2bcd8739ae039(name, value) {
    var names = $6515c3ccac9efd7a$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $6515c3ccac9efd7a$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $6515c3ccac9efd7a$var$classedFunction : value ? $6515c3ccac9efd7a$var$classedTrue : $6515c3ccac9efd7a$var$classedFalse)(names, value));
}


function $23bcbc7d81179ba9$var$textRemove() {
    this.textContent = "";
}
function $23bcbc7d81179ba9$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $23bcbc7d81179ba9$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $23bcbc7d81179ba9$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $23bcbc7d81179ba9$var$textRemove : (typeof value === "function" ? $23bcbc7d81179ba9$var$textFunction : $23bcbc7d81179ba9$var$textConstant)(value)) : this.node().textContent;
}


function $d5514f1406649954$var$htmlRemove() {
    this.innerHTML = "";
}
function $d5514f1406649954$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $d5514f1406649954$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $d5514f1406649954$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $d5514f1406649954$var$htmlRemove : (typeof value === "function" ? $d5514f1406649954$var$htmlFunction : $d5514f1406649954$var$htmlConstant)(value)) : this.node().innerHTML;
}


function $c6aae8ef09c3d03d$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $c6aae8ef09c3d03d$export$2e2bcd8739ae039() {
    return this.each($c6aae8ef09c3d03d$var$raise);
}


function $4669a19c71181bd1$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $4669a19c71181bd1$export$2e2bcd8739ae039() {
    return this.each($4669a19c71181bd1$var$lower);
}




function $8408c2f95f59818f$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) && document.documentElement.namespaceURI === (0, $53f2bc3e7847f93d$export$201a3f7520ccc326) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $8408c2f95f59818f$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $8408c2f95f59818f$export$2e2bcd8739ae039(name) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return (fullname.local ? $8408c2f95f59818f$var$creatorFixed : $8408c2f95f59818f$var$creatorInherit)(fullname);
}


function $00a766249763e814$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}




function $45485f4f27d149f8$var$constantNull() {
    return null;
}
function $45485f4f27d149f8$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $8408c2f95f59818f$export$2e2bcd8739ae039)(name), select = before == null ? $45485f4f27d149f8$var$constantNull : typeof before === "function" ? before : (0, $6e0da2549057218e$export$2e2bcd8739ae039)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}


function $d587d6535138580c$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $d587d6535138580c$export$2e2bcd8739ae039() {
    return this.each($d587d6535138580c$var$remove);
}


function $3323c835dc2d74de$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $3323c835dc2d74de$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $3323c835dc2d74de$var$selection_cloneDeep : $3323c835dc2d74de$var$selection_cloneShallow);
}


function $d048e3258aa4fe8e$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}


function $dd1fb49221ad966f$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $dd1fb49221ad966f$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $dd1fb49221ad966f$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $dd1fb49221ad966f$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $dd1fb49221ad966f$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $dd1fb49221ad966f$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $dd1fb49221ad966f$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $dd1fb49221ad966f$var$onAdd : $dd1fb49221ad966f$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}



function $27c639e461d8a390$var$dispatchEvent(node, type, params) {
    var window = (0, $89f2562a5a0d5a13$export$2e2bcd8739ae039)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $27c639e461d8a390$var$dispatchConstant(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params);
    };
}
function $27c639e461d8a390$var$dispatchFunction(type, params) {
    return function() {
        return $27c639e461d8a390$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $27c639e461d8a390$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $27c639e461d8a390$var$dispatchFunction : $27c639e461d8a390$var$dispatchConstant)(type, params));
}


function* $98373fa9c0ecbfb2$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}


var $28a9f77d63e1ff25$export$e8e78c978b129247 = [
    null
];
function $28a9f77d63e1ff25$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $28a9f77d63e1ff25$var$selection() {
    return new $28a9f77d63e1ff25$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $28a9f77d63e1ff25$export$e8e78c978b129247);
}
function $28a9f77d63e1ff25$var$selection_selection() {
    return this;
}
$28a9f77d63e1ff25$export$52baac22726c72bf.prototype = $28a9f77d63e1ff25$var$selection.prototype = {
    constructor: $28a9f77d63e1ff25$export$52baac22726c72bf,
    select: (0, $31121acbef1e6956$export$2e2bcd8739ae039),
    selectAll: (0, $a3d7edd03ec30cc1$export$2e2bcd8739ae039),
    selectChild: (0, $31ffd623f27a3a65$export$2e2bcd8739ae039),
    selectChildren: (0, $956143cec557381d$export$2e2bcd8739ae039),
    filter: (0, $ebbd333b038c2847$export$2e2bcd8739ae039),
    data: (0, $cf943aeeeea8dffb$export$2e2bcd8739ae039),
    enter: (0, $3e99928b06782938$export$2e2bcd8739ae039),
    exit: (0, $69a673ff94b874e4$export$2e2bcd8739ae039),
    join: (0, $80f6488751784891$export$2e2bcd8739ae039),
    merge: (0, $63bab9b342eb32db$export$2e2bcd8739ae039),
    selection: $28a9f77d63e1ff25$var$selection_selection,
    order: (0, $7a935994b7a1f6cf$export$2e2bcd8739ae039),
    sort: (0, $faed8eab1469f61d$export$2e2bcd8739ae039),
    call: (0, $fa7212ea177e0f60$export$2e2bcd8739ae039),
    nodes: (0, $c2d66609f799a53b$export$2e2bcd8739ae039),
    node: (0, $cb2fe8996a284614$export$2e2bcd8739ae039),
    size: (0, $8d2a1d37edc5fc51$export$2e2bcd8739ae039),
    empty: (0, $3ed6ae19ad0a17a6$export$2e2bcd8739ae039),
    each: (0, $4a407aa055eb21e9$export$2e2bcd8739ae039),
    attr: (0, $8ba31651ad7591ba$export$2e2bcd8739ae039),
    style: (0, $6abb942964e997ae$export$2e2bcd8739ae039),
    property: (0, $2b37810bbc11c28b$export$2e2bcd8739ae039),
    classed: (0, $6515c3ccac9efd7a$export$2e2bcd8739ae039),
    text: (0, $23bcbc7d81179ba9$export$2e2bcd8739ae039),
    html: (0, $d5514f1406649954$export$2e2bcd8739ae039),
    raise: (0, $c6aae8ef09c3d03d$export$2e2bcd8739ae039),
    lower: (0, $4669a19c71181bd1$export$2e2bcd8739ae039),
    append: (0, $00a766249763e814$export$2e2bcd8739ae039),
    insert: (0, $45485f4f27d149f8$export$2e2bcd8739ae039),
    remove: (0, $d587d6535138580c$export$2e2bcd8739ae039),
    clone: (0, $3323c835dc2d74de$export$2e2bcd8739ae039),
    datum: (0, $d048e3258aa4fe8e$export$2e2bcd8739ae039),
    on: (0, $dd1fb49221ad966f$export$2e2bcd8739ae039),
    dispatch: (0, $27c639e461d8a390$export$2e2bcd8739ae039),
    [Symbol.iterator]: (0, $98373fa9c0ecbfb2$export$2e2bcd8739ae039)
};
var $28a9f77d63e1ff25$export$2e2bcd8739ae039 = $28a9f77d63e1ff25$var$selection;


function $cf81072cf307ee25$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $28a9f77d63e1ff25$export$52baac22726c72bf)([
        [
            selector
        ]
    ], (0, $28a9f77d63e1ff25$export$e8e78c978b129247));
}


// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $914edae09cbfb4c0$export$524615cd03e458cc = {
    passive: false
};
const $914edae09cbfb4c0$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $914edae09cbfb4c0$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $914edae09cbfb4c0$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


function $905558291b0c219c$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $905558291b0c219c$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $914edae09cbfb4c0$export$2e2bcd8739ae039), (0, $914edae09cbfb4c0$export$35431a0e47022de1));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}



var $bYoiY = parcelRequire("bYoiY");

var $bYoiY = parcelRequire("bYoiY");
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $dd5733431a2d0880$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $78a660cd70c52f6f$export$2e2bcd8739ae039 = (x)=>()=>x;


function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $529dc8928f6a4077$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $529dc8928f6a4077$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $dd5733431a2d0880$export$2e2bcd8739ae039));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $68731c1c421d9916$export$2e2bcd8739ae039));



function $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $23bbf03008765dcc$export$2e2bcd8739ae039(a, b) {
    return ((0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : $23bbf03008765dcc$export$15d09067c6a5ee49)(a, b);
}
function $23bbf03008765dcc$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $063cbb46f86ba478$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $cf536f4647e343d9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $8385105b4986daed$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $8385105b4986daed$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $78a660cd70c52f6f$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : b instanceof Date ? (0, $063cbb46f86ba478$export$2e2bcd8739ae039) : (0, $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8)(b) ? (0, $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $23bbf03008765dcc$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $cf536f4647e343d9$export$2e2bcd8739ae039) : (0, $bebed377ddb9d3af$export$2e2bcd8739ae039))(a, b);
}


function $c447ae86a8320d39$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}


function $1be794af963d8372$export$2e2bcd8739ae039(event, node) {
    event = (0, $c447ae86a8320d39$export$2e2bcd8739ae039)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}




var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}


function $d15c972f8843a0f2$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $e782289d8bd71451$export$c57e9b2d8b9e4de);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}


var $150ba4634a330696$var$emptyOn = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "end", "cancel", "interrupt");
var $150ba4634a330696$var$emptyTween = [];
var $150ba4634a330696$export$ff39ebd4bb12b718 = 0;
var $150ba4634a330696$export$584530fe98d14a84 = 1;
var $150ba4634a330696$export$a5d151aee16efd42 = 2;
var $150ba4634a330696$export$fb935ab5849a0db9 = 3;
var $150ba4634a330696$export$1573e22b087389af = 4;
var $150ba4634a330696$export$a2e792214ded83b2 = 5;
var $150ba4634a330696$export$9d38167254403955 = 6;
function $150ba4634a330696$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $150ba4634a330696$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $150ba4634a330696$var$emptyOn,
        tween: $150ba4634a330696$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $150ba4634a330696$export$ff39ebd4bb12b718
    });
}
function $150ba4634a330696$export$2cd8252107eb640b(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $150ba4634a330696$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $150ba4634a330696$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $150ba4634a330696$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $150ba4634a330696$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $150ba4634a330696$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $150ba4634a330696$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $150ba4634a330696$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $150ba4634a330696$export$fb935ab5849a0db9) return (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(start);
            // Interrupt the active transition, if any.
            if (o.state === $150ba4634a330696$export$1573e22b087389af) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $150ba4634a330696$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $d15c972f8843a0f2$export$2e2bcd8739ae039)(function() {
            if (self.state === $150ba4634a330696$export$fb935ab5849a0db9) {
                self.state = $150ba4634a330696$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $150ba4634a330696$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $150ba4634a330696$export$a5d151aee16efd42) return; // interrupted
        self.state = $150ba4634a330696$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $150ba4634a330696$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $150ba4634a330696$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $150ba4634a330696$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}


function $b05ce272ee11a654$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $150ba4634a330696$export$a5d151aee16efd42) && schedule.state < (0, $150ba4634a330696$export$a2e792214ded83b2);
        schedule.state = (0, $150ba4634a330696$export$9d38167254403955);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}


function $c1dd383074e2630e$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this, name);
    });
}




var $2938f7d64470581a$var$degrees = 180 / Math.PI;
var $2938f7d64470581a$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $2938f7d64470581a$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $2938f7d64470581a$var$degrees,
        skewX: Math.atan(skewX) * $2938f7d64470581a$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}


var $4a001faa54972590$var$svgNode;
function $4a001faa54972590$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $2938f7d64470581a$export$f0954fd7d5368655) : (0, $2938f7d64470581a$export$2e2bcd8739ae039)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $4a001faa54972590$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    if (!$4a001faa54972590$var$svgNode) $4a001faa54972590$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $4a001faa54972590$var$svgNode.setAttribute("transform", value);
    if (!(value = $4a001faa54972590$var$svgNode.transform.baseVal.consolidate())) return 0, $2938f7d64470581a$export$f0954fd7d5368655;
    value = value.matrix;
    return (0, $2938f7d64470581a$export$2e2bcd8739ae039)(value.a, value.b, value.c, value.d, value.e, value.f);
}


function $e4d1a233c7242264$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $bebed377ddb9d3af$export$2e2bcd8739ae039)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $e4d1a233c7242264$export$56bec7123bb3589a = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$59ad369bf4938177), "px, ", "px)", "deg)");
var $e4d1a233c7242264$export$da8cba906d64c082 = $e4d1a233c7242264$var$interpolateTransform((0, $4a001faa54972590$export$f9ef43f9a1d89a18), ", ", ")", ")");




function $922feb1dfe9c8dcf$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $922feb1dfe9c8dcf$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $922feb1dfe9c8dcf$var$tweenRemove : $922feb1dfe9c8dcf$var$tweenFunction)(id, name, value));
}
function $922feb1dfe9c8dcf$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id).value[name];
    };
}



var $bYoiY = parcelRequire("bYoiY");

function $8a713565676b726d$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $bebed377ddb9d3af$export$2e2bcd8739ae039) : b instanceof (0, $bYoiY.default) ? (0, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (c = (0, $bYoiY.default)(b)) ? (b = c, $e7e88f7f6ed95eef$export$2e2bcd8739ae039) : (0, $020916edd93bff72$export$2e2bcd8739ae039))(a, b);
}


function $2a651cfc4e49b53d$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $2a651cfc4e49b53d$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $2a651cfc4e49b53d$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2a651cfc4e49b53d$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2a651cfc4e49b53d$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name), i = fullname === "transform" ? (0, $e4d1a233c7242264$export$da8cba906d64c082) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $2a651cfc4e49b53d$var$attrFunctionNS : $2a651cfc4e49b53d$var$attrFunction)(fullname, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "attr." + name, value)) : value == null ? (fullname.local ? $2a651cfc4e49b53d$var$attrRemoveNS : $2a651cfc4e49b53d$var$attrRemove)(fullname) : (fullname.local ? $2a651cfc4e49b53d$var$attrConstantNS : $2a651cfc4e49b53d$var$attrConstant)(fullname, i, value));
}



function $cad13035adb29669$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $cad13035adb29669$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $cad13035adb29669$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $cad13035adb29669$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $b659c67af9335162$export$2e2bcd8739ae039)(name);
    return this.tween(key, (fullname.local ? $cad13035adb29669$var$attrTweenNS : $cad13035adb29669$var$attrTween)(fullname, value));
}



function $09cd57996bd81614$var$delayFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = +value.apply(this, arguments);
    };
}
function $09cd57996bd81614$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$2cd8252107eb640b)(this, id).delay = value;
    };
}
function $09cd57996bd81614$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $09cd57996bd81614$var$delayFunction : $09cd57996bd81614$var$delayConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).delay;
}



function $9c9f124117d5bf14$var$durationFunction(id, value) {
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = +value.apply(this, arguments);
    };
}
function $9c9f124117d5bf14$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).duration = value;
    };
}
function $9c9f124117d5bf14$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $9c9f124117d5bf14$var$durationFunction : $9c9f124117d5bf14$var$durationConstant)(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).duration;
}



function $8ea7852b6976e6d1$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = value;
    };
}
function $8ea7852b6976e6d1$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($8ea7852b6976e6d1$var$easeConstant(id, value)) : (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).ease;
}



function $9d186bb80d60f6c9$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id).ease = v;
    };
}
function $9d186bb80d60f6c9$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($9d186bb80d60f6c9$var$easeVarying(this._id, value));
}




function $c1e3543439d9f5fd$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $5fb24786d2a5f87a$export$2e2bcd8739ae039)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, this._name, this._id);
}



function $e7e726720f484153$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(merges, this._parents, this._name, this._id);
}



function $fd664209e896113c$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $fd664209e896113c$var$onFunction(id, name, listener) {
    var on0, on1, sit = $fd664209e896113c$var$start(name) ? (0, $150ba4634a330696$export$2cd8252107eb640b) : (0, $150ba4634a330696$export$adaa4cf7ef1b65be);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $fd664209e896113c$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $150ba4634a330696$export$3988ae62b71be9a3)(this.node(), id).on.on(name) : this.each($fd664209e896113c$var$onFunction(id, name, listener));
}


function $b59e1b517983ad92$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $b59e1b517983ad92$export$2e2bcd8739ae039() {
    return this.on("end.remove", $b59e1b517983ad92$var$removeFunction(this._id));
}





function $9c22ba9ec568d18f$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $6e0da2549057218e$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(subgroup[i], name, id, i, subgroup, (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id));
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, this._parents, name, id);
}





function $79e977f9a26c99f1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $7d92e4f75dbef49d$export$2e2bcd8739ae039)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(subgroups, parents, name, id);
}



var $13be595fcf5febb7$var$Selection = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.constructor;
function $13be595fcf5febb7$export$2e2bcd8739ae039() {
    return new $13be595fcf5febb7$var$Selection(this._groups, this._parents);
}







function $d0bf366fdef4c332$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), string1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $d0bf366fdef4c332$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d0bf366fdef4c332$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $d0bf366fdef4c332$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $6abb942964e997ae$export$5e3cec964f0b5efd)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $d0bf366fdef4c332$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $d0bf366fdef4c332$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $d0bf366fdef4c332$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $e4d1a233c7242264$export$56bec7123bb3589a) : (0, $8a713565676b726d$export$2e2bcd8739ae039);
    return value == null ? this.styleTween(name, $d0bf366fdef4c332$var$styleNull(name, i)).on("end.style." + name, $d0bf366fdef4c332$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $d0bf366fdef4c332$var$styleFunction(name, i, (0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "style." + name, value))).each($d0bf366fdef4c332$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $d0bf366fdef4c332$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}


function $83672080502c9717$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $83672080502c9717$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $83672080502c9717$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $83672080502c9717$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $83672080502c9717$var$styleTween(name, value, priority == null ? "" : priority));
}



function $e62b6dd5e7df40e7$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $e62b6dd5e7df40e7$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $e62b6dd5e7df40e7$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $e62b6dd5e7df40e7$var$textFunction((0, $922feb1dfe9c8dcf$export$f78ce6ab10405d82)(this, "text", value)) : $e62b6dd5e7df40e7$var$textConstant(value == null ? "" : value + ""));
}


function $64d823b28aa7019a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $64d823b28aa7019a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $64d823b28aa7019a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $64d823b28aa7019a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $64d823b28aa7019a$var$textTween(value));
}




function $e8ee9e113d6ecbba$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $150ba4634a330696$export$3988ae62b71be9a3)(node, id0);
            (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id1);
}




function $5220ae42feb560ba$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $150ba4634a330696$export$adaa4cf7ef1b65be)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}


var $a4d5b9ef4f9cfabb$var$id = 0;
function $a4d5b9ef4f9cfabb$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039(name) {
    return (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039)().transition(name);
}
function $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b() {
    return ++$a4d5b9ef4f9cfabb$var$id;
}
var $a4d5b9ef4f9cfabb$var$selection_prototype = (0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype;
$a4d5b9ef4f9cfabb$export$be58926105124dd4.prototype = $a4d5b9ef4f9cfabb$export$2e2bcd8739ae039.prototype = {
    constructor: $a4d5b9ef4f9cfabb$export$be58926105124dd4,
    select: (0, $9c22ba9ec568d18f$export$2e2bcd8739ae039),
    selectAll: (0, $79e977f9a26c99f1$export$2e2bcd8739ae039),
    selectChild: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChild,
    selectChildren: $a4d5b9ef4f9cfabb$var$selection_prototype.selectChildren,
    filter: (0, $c1e3543439d9f5fd$export$2e2bcd8739ae039),
    merge: (0, $e7e726720f484153$export$2e2bcd8739ae039),
    selection: (0, $13be595fcf5febb7$export$2e2bcd8739ae039),
    transition: (0, $e8ee9e113d6ecbba$export$2e2bcd8739ae039),
    call: $a4d5b9ef4f9cfabb$var$selection_prototype.call,
    nodes: $a4d5b9ef4f9cfabb$var$selection_prototype.nodes,
    node: $a4d5b9ef4f9cfabb$var$selection_prototype.node,
    size: $a4d5b9ef4f9cfabb$var$selection_prototype.size,
    empty: $a4d5b9ef4f9cfabb$var$selection_prototype.empty,
    each: $a4d5b9ef4f9cfabb$var$selection_prototype.each,
    on: (0, $fd664209e896113c$export$2e2bcd8739ae039),
    attr: (0, $2a651cfc4e49b53d$export$2e2bcd8739ae039),
    attrTween: (0, $cad13035adb29669$export$2e2bcd8739ae039),
    style: (0, $d0bf366fdef4c332$export$2e2bcd8739ae039),
    styleTween: (0, $83672080502c9717$export$2e2bcd8739ae039),
    text: (0, $e62b6dd5e7df40e7$export$2e2bcd8739ae039),
    textTween: (0, $64d823b28aa7019a$export$2e2bcd8739ae039),
    remove: (0, $b59e1b517983ad92$export$2e2bcd8739ae039),
    tween: (0, $922feb1dfe9c8dcf$export$2e2bcd8739ae039),
    delay: (0, $09cd57996bd81614$export$2e2bcd8739ae039),
    duration: (0, $9c9f124117d5bf14$export$2e2bcd8739ae039),
    ease: (0, $8ea7852b6976e6d1$export$2e2bcd8739ae039),
    easeVarying: (0, $9d186bb80d60f6c9$export$2e2bcd8739ae039),
    end: (0, $5220ae42feb560ba$export$2e2bcd8739ae039),
    [Symbol.iterator]: $a4d5b9ef4f9cfabb$var$selection_prototype[Symbol.iterator]
};



function $5b131c7b61a09e82$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $5b131c7b61a09e82$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $5b131c7b61a09e82$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



var $b5b43281074f9351$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $5b131c7b61a09e82$export$89238d3bc79d3ada)
};
function $b5b43281074f9351$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $b5b43281074f9351$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)) id = name._id, name = name._name;
    else id = (0, $a4d5b9ef4f9cfabb$export$9ffd10a3fbdc175b)(), (timing = $b5b43281074f9351$var$defaultTiming).time = (0, $e782289d8bd71451$export$461939dd4422153)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $150ba4634a330696$export$2e2bcd8739ae039)(node, name, id, i, group, timing || $b5b43281074f9351$var$inherit(node, id));
    }
    return new (0, $a4d5b9ef4f9cfabb$export$be58926105124dd4)(groups, this._parents, name, id);
}


(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.interrupt = (0, $c1dd383074e2630e$export$2e2bcd8739ae039);
(0, $28a9f77d63e1ff25$export$2e2bcd8739ae039).prototype.transition = (0, $b5b43281074f9351$export$2e2bcd8739ae039);







var $4fc3d848825eb4c8$export$2e2bcd8739ae039 = (x)=>()=>x;


function $de0b5bec424cf247$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $48e2d3ac3b9a75ee$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $48e2d3ac3b9a75ee$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


var $5c8970f4694d4107$var$MODE_DRAG = {
    name: "drag"
}, $5c8970f4694d4107$var$MODE_SPACE = {
    name: "space"
}, $5c8970f4694d4107$var$MODE_HANDLE = {
    name: "handle"
}, $5c8970f4694d4107$var$MODE_CENTER = {
    name: "center"
};
const { abs: $5c8970f4694d4107$var$abs, max: $5c8970f4694d4107$var$max, min: $5c8970f4694d4107$var$min } = Math;
function $5c8970f4694d4107$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $5c8970f4694d4107$var$number2(e) {
    return [
        $5c8970f4694d4107$var$number1(e[0]),
        $5c8970f4694d4107$var$number1(e[1])
    ];
}
var $5c8970f4694d4107$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($5c8970f4694d4107$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $5c8970f4694d4107$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($5c8970f4694d4107$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $5c8970f4694d4107$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($5c8970f4694d4107$var$type),
    input: function(xy) {
        return xy == null ? null : $5c8970f4694d4107$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $5c8970f4694d4107$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $5c8970f4694d4107$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $5c8970f4694d4107$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $5c8970f4694d4107$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $5c8970f4694d4107$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $5c8970f4694d4107$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $5c8970f4694d4107$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $5c8970f4694d4107$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $5c8970f4694d4107$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $5c8970f4694d4107$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $5c8970f4694d4107$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $5c8970f4694d4107$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $5c8970f4694d4107$export$979ace6c88860aa8() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$X);
}
function $5c8970f4694d4107$export$468748b530991c54() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$Y);
}
function $5c8970f4694d4107$export$2e2bcd8739ae039() {
    return $5c8970f4694d4107$var$brush($5c8970f4694d4107$var$XY);
}
function $5c8970f4694d4107$var$brush(dim) {
    var extent = $5c8970f4694d4107$var$defaultExtent, filter = $5c8970f4694d4107$var$defaultFilter, touchable = $5c8970f4694d4107$var$defaultTouchable, keys = true, listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $5c8970f4694d4107$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $5c8970f4694d4107$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $5c8970f4694d4107$var$local(this).extent;
            (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $5c8970f4694d4107$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $5c8970f4694d4107$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $5c8970f4694d4107$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $8385105b4986daed$export$2e2bcd8739ae039)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this), selection = $5c8970f4694d4107$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $de0b5bec424cf247$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $5c8970f4694d4107$var$MODE_DRAG : keys && event.altKey ? $5c8970f4694d4107$var$MODE_CENTER : $5c8970f4694d4107$var$MODE_HANDLE, signX = dim === $5c8970f4694d4107$var$Y ? null : $5c8970f4694d4107$var$signsX[type], signY = dim === $5c8970f4694d4107$var$X ? null : $5c8970f4694d4107$var$signsY[type], state = $5c8970f4694d4107$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $5c8970f4694d4107$var$Y ? W : $5c8970f4694d4107$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $5c8970f4694d4107$var$X ? N : $5c8970f4694d4107$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $5c8970f4694d4107$var$Y ? E : $5c8970f4694d4107$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $5c8970f4694d4107$var$X ? S : $5c8970f4694d4107$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $5c8970f4694d4107$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $1be794af963d8372$export$2e2bcd8739ae039)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($5c8970f4694d4107$var$abs(point.cur[0] - point[0]) > $5c8970f4694d4107$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $5c8970f4694d4107$var$MODE_SPACE:
                case $5c8970f4694d4107$var$MODE_DRAG:
                    if (signX) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $5c8970f4694d4107$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[0][0])), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[0][1])), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $5c8970f4694d4107$var$max(W - w0, $5c8970f4694d4107$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $5c8970f4694d4107$var$max(W - e0, $5c8970f4694d4107$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $5c8970f4694d4107$var$max(N - n0, $5c8970f4694d4107$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $5c8970f4694d4107$var$max(N - s0, $5c8970f4694d4107$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $5c8970f4694d4107$var$MODE_CENTER:
                    if (signX) w1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, w0 - dx * signX)), e1 = $5c8970f4694d4107$var$max(W, $5c8970f4694d4107$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, n0 - dy * signY)), s1 = $5c8970f4694d4107$var$max(N, $5c8970f4694d4107$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $5c8970f4694d4107$var$flipX) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $5c8970f4694d4107$var$flipY) overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type = $5c8970f4694d4107$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $48e2d3ac3b9a75ee$export$2e2561858db9bf47)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $905558291b0c219c$export$833237748009e1e1)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $5c8970f4694d4107$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($5c8970f4694d4107$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $5c8970f4694d4107$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_HANDLE || mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $5c8970f4694d4107$var$MODE_SPACE;
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $5c8970f4694d4107$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $5c8970f4694d4107$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $5c8970f4694d4107$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $5c8970f4694d4107$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $5c8970f4694d4107$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $48e2d3ac3b9a75ee$export$2e2bcd8739ae039)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $5c8970f4694d4107$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)($5c8970f4694d4107$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4fc3d848825eb4c8$export$2e2bcd8739ae039)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}













var $620ab3a49fccb4fc$export$2e2bcd8739ae039 = (x)=>()=>x;


function $45813ed5c6fd1799$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
$45813ed5c6fd1799$export$2e2bcd8739ae039.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};


// Ignore right-click, since that should open the context menu.
function $0b4a1789c016a21b$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $0b4a1789c016a21b$var$defaultContainer() {
    return this.parentNode;
}
function $0b4a1789c016a21b$var$defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function $0b4a1789c016a21b$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $0b4a1789c016a21b$export$2e2bcd8739ae039() {
    var filter = $0b4a1789c016a21b$var$defaultFilter, container = $0b4a1789c016a21b$var$defaultContainer, subject = $0b4a1789c016a21b$var$defaultSubject, touchable = $0b4a1789c016a21b$var$defaultTouchable, gestures = {}, listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
    function drag(selection) {
        selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, $914edae09cbfb4c0$export$524615cd03e458cc)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    function mousedowned(event, d) {
        if (touchending || !filter.call(this, event, d)) return;
        var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
        if (!gesture) return;
        (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.drag", mousemoved, (0, $914edae09cbfb4c0$export$35431a0e47022de1)).on("mouseup.drag", mouseupped, (0, $914edae09cbfb4c0$export$35431a0e47022de1));
        (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        (0, $914edae09cbfb4c0$export$2e2561858db9bf47)(event);
        mousemoving = false;
        mousedownx = event.clientX;
        mousedowny = event.clientY;
        gesture("start", event);
    }
    function mousemoved(event) {
        (0, $914edae09cbfb4c0$export$2e2bcd8739ae039)(event);
        if (!mousemoving) {
            var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
            mousemoving = dx * dx + dy * dy > clickDistance2;
        }
        gestures.mouse("drag", event);
    }
    function mouseupped(event) {
        (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.drag mouseup.drag", null);
        (0, $905558291b0c219c$export$833237748009e1e1)(event.view, mousemoving);
        (0, $914edae09cbfb4c0$export$2e2bcd8739ae039)(event);
        gestures.mouse("end", event);
    }
    function touchstarted(event, d) {
        if (!filter.call(this, event, d)) return;
        var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
            (0, $914edae09cbfb4c0$export$2e2561858db9bf47)(event);
            gesture("start", event, touches[i]);
        }
    }
    function touchmoved(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $914edae09cbfb4c0$export$2e2bcd8739ae039)(event);
            gesture("drag", event, touches[i]);
        }
    }
    function touchended(event) {
        var touches = event.changedTouches, n = touches.length, i, gesture;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, 500); // Ghost clicks are delayed!
        for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
            (0, $914edae09cbfb4c0$export$2e2561858db9bf47)(event);
            gesture("end", event, touches[i]);
        }
    }
    function beforestart(that, container, event, d, identifier, touch) {
        var dispatch = listeners.copy(), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(touch || event, container), dx, dy, s;
        if ((s = subject.call(that, new (0, $45813ed5c6fd1799$export$2e2bcd8739ae039)("beforestart", {
            sourceEvent: event,
            target: drag,
            identifier: identifier,
            active: active,
            x: p[0],
            y: p[1],
            dx: 0,
            dy: 0,
            dispatch: dispatch
        }), d)) == null) return;
        dx = s.x - p[0] || 0;
        dy = s.y - p[1] || 0;
        return function gesture(type, event, touch) {
            var p0 = p, n;
            switch(type){
                case "start":
                    gestures[identifier] = gesture, n = active++;
                    break;
                case "end":
                    delete gestures[identifier], --active; // falls through
                case "drag":
                    p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(touch || event, container), n = active;
                    break;
            }
            dispatch.call(type, that, new (0, $45813ed5c6fd1799$export$2e2bcd8739ae039)(type, {
                sourceEvent: event,
                subject: s,
                target: drag,
                identifier: identifier,
                active: n,
                x: p[0] + dx,
                y: p[1] + dy,
                dx: p[0] - p0[0],
                dy: p[1] - p0[1],
                dispatch: dispatch
            }), d);
        };
    }
    drag.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(!!_), drag) : filter;
    };
    drag.container = function(_) {
        return arguments.length ? (container = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(_), drag) : container;
    };
    drag.subject = function(_) {
        return arguments.length ? (subject = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(_), drag) : subject;
    };
    drag.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $620ab3a49fccb4fc$export$2e2bcd8739ae039)(!!_), drag) : touchable;
    };
    drag.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? drag : value;
    };
    drag.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
    };
    return drag;
}





function $32b22de0132cc595$export$2e2bcd8739ae039(x, y) {
    var nodes, strength = 1;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    return force;
}

function $be1b12895c7da8cf$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $be1b12895c7da8cf$var$add(this.cover(x, y), x, y, d);
}
function $be1b12895c7da8cf$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $be1b12895c7da8cf$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$be1b12895c7da8cf$var$add(this, xz[i], yz[i], data[i]);
    return this;
}


function $6063f984171c8523$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}


function $cfd8a0ee53f875c5$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}


function $feddd81cb3a1a5cd$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}


function $75f49fd5af8d23e7$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}


function $b7a6a4e6ea4402cb$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[3], xm, ym, x2, y2), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[2], x1, ym, xm, y2), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[1], xm, y1, x2, ym), new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}


function $9ea7286cd6ff459a$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $9ea7286cd6ff459a$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}


function $0d9e2b498bba95b5$export$2e2bcd8739ae039() {
    return this._root;
}


function $f92329c600392ac7$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}



function $15a5c85e382805ba$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
    }
    return this;
}



function $9a4dcb6a46603c0e$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $75f49fd5af8d23e7$export$2e2bcd8739ae039)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}


function $e002de94352e4f40$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $e002de94352e4f40$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}


function $6a00482922687876$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $6a00482922687876$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}


function $977cc0295d3f184c$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $977cc0295d3f184c$var$Quadtree(x == null ? (0, $e002de94352e4f40$export$e6fafc98131d2a44) : x, y == null ? (0, $6a00482922687876$export$6f0a21aeb844a64c) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $977cc0295d3f184c$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $977cc0295d3f184c$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $977cc0295d3f184c$var$treeProto = $977cc0295d3f184c$export$2e2bcd8739ae039.prototype = $977cc0295d3f184c$var$Quadtree.prototype;
$977cc0295d3f184c$var$treeProto.copy = function() {
    var copy = new $977cc0295d3f184c$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $977cc0295d3f184c$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $977cc0295d3f184c$var$leaf_copy(child);
        }
    }
    return copy;
};
$977cc0295d3f184c$var$treeProto.add = (0, $be1b12895c7da8cf$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.addAll = (0, $be1b12895c7da8cf$export$32ed0561867ec8a1);
$977cc0295d3f184c$var$treeProto.cover = (0, $6063f984171c8523$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.data = (0, $cfd8a0ee53f875c5$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.extent = (0, $feddd81cb3a1a5cd$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.find = (0, $b7a6a4e6ea4402cb$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.remove = (0, $9ea7286cd6ff459a$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.removeAll = (0, $9ea7286cd6ff459a$export$1cfc7aad5cb1833b);
$977cc0295d3f184c$var$treeProto.root = (0, $0d9e2b498bba95b5$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.size = (0, $f92329c600392ac7$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.visit = (0, $15a5c85e382805ba$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.visitAfter = (0, $9a4dcb6a46603c0e$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.x = (0, $e002de94352e4f40$export$2e2bcd8739ae039);
$977cc0295d3f184c$var$treeProto.y = (0, $6a00482922687876$export$2e2bcd8739ae039);


function $b10509a5c523ef79$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $2dea4bbaea189065$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}


function $bdd28c4fe1fd882d$var$x(d) {
    return d.x + d.vx;
}
function $bdd28c4fe1fd882d$var$y(d) {
    return d.y + d.vy;
}
function $bdd28c4fe1fd882d$export$2e2bcd8739ae039(radius) {
    var nodes, radii, random, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $977cc0295d3f184c$export$2e2bcd8739ae039)(nodes, $bdd28c4fe1fd882d$var$x, $bdd28c4fe1fd882d$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(random), l += x * x;
                        if (y === 0) y = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(random), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : radius;
    };
    return force;
}



function $4275f440a0eccb35$var$index(d) {
    return d.index;
}
function $4275f440a0eccb35$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}
function $4275f440a0eccb35$export$2e2bcd8739ae039(links) {
    var id = $4275f440a0eccb35$var$index, strength = defaultStrength, strengths, distance = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(30), distances, nodes, count, bias, random, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(random);
            y = target.y + target.vy - source.y - source.vy || (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(random);
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ])), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $4275f440a0eccb35$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $4275f440a0eccb35$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initializeDistance(), force) : distance;
    };
    return force;
}






// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $2a41329dd990bdd6$var$a = 1664525;
const $2a41329dd990bdd6$var$c = 1013904223;
const $2a41329dd990bdd6$var$m = 4294967296; // 2^32
function $2a41329dd990bdd6$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($2a41329dd990bdd6$var$a * s + $2a41329dd990bdd6$var$c) % $2a41329dd990bdd6$var$m) / $2a41329dd990bdd6$var$m;
}


function $f7ecda670cf68ae1$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $f7ecda670cf68ae1$export$4a5767248b18ef41(d) {
    return d.y;
}
var $f7ecda670cf68ae1$var$initialRadius = 10, $f7ecda670cf68ae1$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $f7ecda670cf68ae1$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $e782289d8bd71451$export$9dc4ecf953986f04)(step), event = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("tick", "end"), random = (0, $2a41329dd990bdd6$export$2e2bcd8739ae039)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $f7ecda670cf68ae1$var$initialRadius * Math.sqrt(0.5 + i), angle = i * $f7ecda670cf68ae1$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}


function $6b6e9bc7f2e1a0ee$export$2e2bcd8739ae039() {
    var nodes, node, random, alpha, strength = (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $977cc0295d3f184c$export$2e2bcd8739ae039)(nodes, (0, $f7ecda670cf68ae1$export$d141bba7fdc215a3), (0, $f7ecda670cf68ae1$export$4a5767248b18ef41)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(random), l += x * x;
                if (y === 0) y = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(random), l += x * x;
            if (y === 0) y = (0, $2dea4bbaea189065$export$2e2bcd8739ae039)(random), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $b10509a5c523ef79$export$2e2bcd8739ae039)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}




















var $e4199827a75856fd$var$epsilon2 = 1e-12;
function $e4199827a75856fd$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $e4199827a75856fd$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $e4199827a75856fd$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $e4199827a75856fd$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $e4199827a75856fd$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $e4199827a75856fd$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $e4199827a75856fd$var$tanh(rho * s + r0) - $e4199827a75856fd$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $e4199827a75856fd$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);




var $4aeb7326706b2467$export$2e2bcd8739ae039 = (x)=>()=>x;


function $7a8a51016481311d$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}


function $a3c1094a2e8782d7$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$a3c1094a2e8782d7$export$563a914cafbdc389.prototype = {
    constructor: $a3c1094a2e8782d7$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $a3c1094a2e8782d7$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $a3c1094a2e8782d7$export$f0954fd7d5368655 = new $a3c1094a2e8782d7$export$563a914cafbdc389(1, 0, 0);
$a3c1094a2e8782d7$export$2e2bcd8739ae039.prototype = $a3c1094a2e8782d7$export$563a914cafbdc389.prototype;
function $a3c1094a2e8782d7$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $a3c1094a2e8782d7$export$f0954fd7d5368655;
    return node.__zoom;
}


function $b2e4663bd9fbfcc1$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $b2e4663bd9fbfcc1$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}


// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $91e02783b8b1c24a$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === "wheel") && !event.button;
}
function $91e02783b8b1c24a$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $91e02783b8b1c24a$var$defaultTransform() {
    return this.__zoom || (0, $a3c1094a2e8782d7$export$f0954fd7d5368655);
}
function $91e02783b8b1c24a$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $91e02783b8b1c24a$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $91e02783b8b1c24a$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $91e02783b8b1c24a$export$2e2bcd8739ae039() {
    var filter = $91e02783b8b1c24a$var$defaultFilter, extent = $91e02783b8b1c24a$var$defaultExtent, constrain = $91e02783b8b1c24a$var$defaultConstrain, wheelDelta = $91e02783b8b1c24a$var$defaultWheelDelta, touchable = $91e02783b8b1c24a$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $e4199827a75856fd$export$2e2bcd8739ae039), listeners = (0, $7c4cf709d1826294$export$2e2bcd8739ae039)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $91e02783b8b1c24a$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $a3c1094a2e8782d7$export$f0954fd7d5368655).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $a3c1094a2e8782d7$export$563a914cafbdc389)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this.that).datum();
            listeners.call(type, this.that, new (0, $7a8a51016481311d$export$2e2bcd8739ae039)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $905558291b0c219c$export$2e2bcd8739ae039)(event.view);
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
        g.start();
        function mousemoved(event) {
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $905558291b0c219c$export$833237748009e1e1)(event.view, g.moved);
            (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $1be794af963d8372$export$2e2bcd8739ae039)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        if (duration > 0) (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $b05ce272ee11a654$export$2e2bcd8739ae039)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $b2e4663bd9fbfcc1$export$2e2bcd8739ae039)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $b2e4663bd9fbfcc1$export$2e2561858db9bf47)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $1be794af963d8372$export$2e2bcd8739ae039)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $cf81072cf307ee25$export$2e2bcd8739ae039)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4aeb7326706b2467$export$2e2bcd8739ae039)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}







const $b29cbd46e8b223e2$export$f8f7704cf2554ba7 = "0.5px";
const $b29cbd46e8b223e2$export$f6d5c12b28a0e5f1 = "#bdbdbd";
const $b29cbd46e8b223e2$export$3a1de8ec2eb2c34e = 5;
const $b29cbd46e8b223e2$export$3f37eb6d9c471e4b = "#5c5c5c";
const $b29cbd46e8b223e2$export$48ebe87ff37a9838 = 250;
const $b29cbd46e8b223e2$export$a0fdc1845229ff21 = 15;
const $b29cbd46e8b223e2$export$c0f24b85f28741e4 = 860;


class $4fd25a700b7c2bb6$export$2e2bcd8739ae039 {
    _parentElementId;
    _container;
    _containerEl;
    width;
    height;
    offsetWidth;
    _data;
    _svg;
    _simulation;
    _graphGroup;
    _links;
    _nodes;
    tooltip;
    isTooltipHovered;
    currentNode;
    currentNodeEl;
    tooltipRemovalTimeout;
    btnResizeEl;
    renderView(data) {
        // this.renderSpinner(); FIXME: icon is not read
        this._data = data;
        this.clearHTML(this._containerEl);
        this.createSVG();
        this.renderSimulation();
        this.createGraphGroup();
        this.renderLinks();
        this.renderNodes();
        this.addHandlerZoom();
        this.addHandlerDrag();
        this.createTooltipElement();
        // Bind events based on device type
        if (this.isMobile()) this.bindMobileEvents();
        else this.bindDesktopEvents();
        this.addHandlerHoverTooltip();
        this.addHandlerReloadSVG();
    }
    //HELPERS METHODS
    toggleHidden(element) {
        element.classList.toggle("hidden");
    }
    clearHTML(element) {
        element.innerHTML = "";
    }
    capitalize(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }
    calculateContainerWidth() {
        return this.width = this._parentElementId.offsetWidth / this.offsetWidth;
    }
    calculateContainerHeight() {
        return this.height = this._parentElementId.offsetHeight;
    }
    reRenderView(classInstance, getClonedData) {
        const newData = getClonedData();
        classInstance.clearHTML(classInstance._containerEl);
        classInstance.renderView(newData);
        this.currentNode = null; // allows to select new nodes
    }
    isMobile() {
        // Adjust the threshold as needed. Here we use 768px as an example.
        return window.innerWidth <= 768;
    }
    // renderSpinner() {
    //   this._containerEl.insertAdjacentHTML(
    //     'afterbegin',
    //     `<div class="spinner">
    //   <svg>
    //   <symbol id="icon-loader" viewBox="0 0 24 24">
    //   <path d="M11 2v4c0 0.552 0.448 1 1 1s1-0.448 1-1v-4c0-0.552-0.448-1-1-1s-1 0.448-1 1zM11 18v4c0 0.552 0.448 1 1 1s1-0.448 1-1v-4c0-0.552-0.448-1-1-1s-1 0.448-1 1zM4.223 5.637l2.83 2.83c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-2.83-2.83c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414zM15.533 16.947l2.83 2.83c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-2.83-2.83c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414zM2 13h4c0.552 0 1-0.448 1-1s-0.448-1-1-1h-4c-0.552 0-1 0.448-1 1s0.448 1 1 1zM18 13h4c0.552 0 1-0.448 1-1s-0.448-1-1-1h-4c-0.552 0-1 0.448-1 1s0.448 1 1 1zM5.637 19.777l2.83-2.83c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-2.83 2.83c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0zM16.947 8.467l2.83-2.83c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-2.83 2.83c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0z"></path>
    //   </symbol>
    //   </svg>
    // </div>`
    //   );
    // }
    //GRAPH
    createSVG() {
        return (this._svg = $cf81072cf307ee25$export$2e2bcd8739ae039(this._container).append("svg").classed("graph-svg", true) // .graph-svg not defined !!!
        .attr("width", this.width).attr("height", this.height).attr("viewport", [
            0,
            0,
            this.width,
            this.height
        ]) // Create SVG
        ).style("border", "solid 1px #afafaf").style("overflow", "hidden");
    }
    renderSimulation() {
        return this._simulation = $f7ecda670cf68ae1$export$2e2bcd8739ae039(this._data.nodes).force("link", $4275f440a0eccb35$export$2e2bcd8739ae039(this._data.links).id((d)=>d.id).distance((0, $b29cbd46e8b223e2$export$48ebe87ff37a9838))).force("charge", $6b6e9bc7f2e1a0ee$export$2e2bcd8739ae039().distanceMax(100)).force("center", $32b22de0132cc595$export$2e2bcd8739ae039(this.width / 2, this.height / 2)).force("collide", $bdd28c4fe1fd882d$export$2e2bcd8739ae039().radius((d)=>{
            // Basic approach: add some buffer to the node radius
            // so that labels have space
            const labelPadding = 40; // extra space for the label
            return (0, $b29cbd46e8b223e2$export$3a1de8ec2eb2c34e) + labelPadding;
        }).iterations(2) // you can experiment with iteration count
        ).on("tick", ()=>this.ticked());
    }
    ticked() {
        // Update link positions
        this._links.attr("x1", (d)=>d.source.x).attr("x2", (d)=>d.target.x).attr("y1", (d)=>d.source.y).attr("y2", (d)=>d.target.y);
        // Update node positions - this only updates visualization, not the datum (data)
        this._nodes.attr("transform", (d)=>`translate(${d.x}, ${d.y})`);
    }
    createGraphGroup() {
        return this._graphGroup = this._svg.append("g");
    }
    renderLinks() {
        this._links = this._graphGroup.selectAll("line").data(this._data.links).join("line").attr("stroke", (0, $b29cbd46e8b223e2$export$f6d5c12b28a0e5f1)).attr("stroke-width", (0, $b29cbd46e8b223e2$export$f8f7704cf2554ba7));
        return this._links;
    }
    renderNodes() {
        this.createNodeGroups();
        this.createNodesCircles();
        this.createNodesLabels();
    }
    createNodeGroups() {
        return this._nodes = this._graphGroup.attr("class", "nodes").selectAll("g").data(this._data.nodes).enter() // enter the nodes from the array?
        .append("g"); // create 1 group per node (d)
    }
    createNodesCircles() {
        this._nodes.append("circle").attr("r", (0, $b29cbd46e8b223e2$export$3a1de8ec2eb2c34e)).attr("fill", (0, $b29cbd46e8b223e2$export$3f37eb6d9c471e4b)).classed("select-element", true);
    }
    createNodesLabels() {
        this._nodes.append("text").text((d)=>d.id).attr("x", 0) // Center the text relative to the group
        .attr("y", (0, $b29cbd46e8b223e2$export$a0fdc1845229ff21)) // Position the text below the circle relative to the group
        .attr("text-anchor", "middle") // Ensure the text is centered horizontally relative to itself
        .attr("alignment-baseline", "middle") // Ensure the text is centered vertically relative to itself
        .classed("cursor", true);
    }
    //ZOOM METHODS
    addHandlerZoom() {
        // 1) Create a zoom behavior with your desired scale range
        const zoomBehavior = $91e02783b8b1c24a$export$2e2bcd8739ae039().scaleExtent([
            0.1,
            10
        ]).on("zoom", (event)=>{
            // 2) Apply the transform to the main <g> container
            this._graphGroup.attr("transform", event.transform);
        });
        // 3) Attach the zoom behavior to the SVG
        this._svg.call(zoomBehavior);
    }
    //DRAGGING
    addHandlerDrag() {
        this._nodes.call($0b4a1789c016a21b$export$2e2bcd8739ae039().on("start", (event)=>this.activateStartDragging(event)).on("drag", (event)=>this.activateDragging(event)).on("end", (event)=>this.activateEndDragging(event)));
    }
    activateStartDragging(event) {
        if (!event.active) {
            this._simulation.alphaTarget(0.3).restart();
            event.subject.fx = event.subject.x;
            event.subject.fy = event.subject.y;
        }
    }
    activateDragging(event) {
        event.subject.fx = event.x;
        event.subject.fy = event.y;
        // Remove tooltip while dragging
        this.removeTooltip();
    }
    activateEndDragging(event) {
        if (!event.active) {
            this._simulation.alphaTarget(0);
            event.subject.fx = null;
            event.subject.fy = null;
        }
    }
    // FIXME: timeout is not working / DELETE
    addHandlerNodesEnterEvents() {
        this._nodes.selectAll("circle").on("pointerenter", (event, d)=>{
            // Store reference to the node group (parent element) for later removal of highlight
            this.currentNodeEl = event.currentTarget.parentNode; // HTML
            this.renderNodesHighlight(d, this.currentNodeEl);
            this.addHandlerRenderTooltip(event, d);
            if (this.currentNode === d) clearTimeout(this.tooltipRemovalTimeout); // timeout for tooltip is cleared only if you are entering the same node
            else this.currentNode = d;
        });
    }
    // HANDLERS FOR EVENTS
    bindDesktopEvents() {
        // On click: if no highlight is active, highlight the clicked node and its connected nodes,
        // and show the tooltip for the clicked node.
        this._nodes.selectAll("circle").on("click", (event, d)=>{
            // Prevent new highlights if one is already active.
            if (this.currentNode) return;
            // Store the node group element for later reference.
            this.currentNodeEl = event.currentTarget.parentNode;
            // Highlight the clicked node and its connections.
            this.renderNodesHighlight(d, this.currentNodeEl);
            // Show tooltip for the clicked node.
            this.addHandlerRenderTooltip(event, d);
            // Set the current highlighted node.
            this.currentNode = d;
        });
        // Attach pointerenter to update the tooltip only for nodes that are part of the highlighted set.
        this._nodes.selectAll("circle").on("pointerenter", (event, d)=>{
            const nodeGroup = event.currentTarget.parentNode;
            if (d === this.currentNode || $cf81072cf307ee25$export$2e2bcd8739ae039(nodeGroup).classed("highlighted-ConnectedNode")) this.addHandlerRenderTooltip(event, d);
        });
        this._nodes.selectAll("circle").on("pointerleave", (event, d)=>{
            // If leaving a highlighted connected node, revert tooltip to currentNode info.
            this.scheduleTooltipRemoval(this.isTooltipHovered);
        });
    // Reload svg when screens change
    }
    bindMobileEvents() {
        // On tap: if no highlight is active, highlight the tapped node and its connected nodes,
        // and show the tooltip for the tapped node.
        this._nodes.selectAll("circle").on("click", (event, d)=>{
            const nodeGroup = event.currentTarget.parentNode;
            // If no node is highlighted yet, do the initial highlight.
            if (!this.currentNode) {
                this.currentNodeEl = nodeGroup;
                this.renderNodesHighlight(d, nodeGroup);
                this.addHandlerRenderTooltip(event, d);
                this.currentNode = d;
            } else // If a node is already highlighted, only update the tooltip if the tapped node
            // is either the target or one of its connected nodes.
            if (d === this.currentNode || $cf81072cf307ee25$export$2e2bcd8739ae039(nodeGroup).classed("highlighted-ConnectedNode")) this.addHandlerRenderTooltip(event, d);
        });
    }
    //HIGHLIGHT NODES
    renderNodesHighlight(d, currentNode) {
        // Reduce the opacity of all nodes and links
        this.applyOverlayToAll();
        // Apply highlighted style to target node
        this.highlightTargetNode(currentNode);
        // Apply highlight style to the connected elements
        this.highlightConnections(d);
    }
    applyOverlayToAll() {
        this._nodes.classed("overlayed", true);
        this._links.classed("overlayed-links", true);
    }
    highlightTargetNode(nodeElement) {
        $cf81072cf307ee25$export$2e2bcd8739ae039(nodeElement).select("circle").classed("highlighted-node", true);
        $cf81072cf307ee25$export$2e2bcd8739ae039(nodeElement).classed("overlayed", false).select("text").transition().duration(200).attr("y", (0, $b29cbd46e8b223e2$export$a0fdc1845229ff21) + 5);
    }
    unhighlightTargetNode(nodeElement) {
        $cf81072cf307ee25$export$2e2bcd8739ae039(nodeElement).classed("overlayed", false).select("circle").classed("highlighted-node", false);
        $cf81072cf307ee25$export$2e2bcd8739ae039(nodeElement).transition().duration(200).select("text").attr("y", (0, $b29cbd46e8b223e2$export$a0fdc1845229ff21));
    }
    // Takes in the d (datum) from the event handler. the d is target node in the form of object (as in state)
    highlightConnections(d) {
        const connectedLinks = this.getConnectedLinks(d);
        const connectedNodeIds = this.getConnectedNodes(connectedLinks);
        this._links.filter((link)=>connectedLinks.includes(link)).classed("highlighted-link", true).classed("overlayed-links", false);
        this._nodes.each(function(nodeData) {
            if (nodeData.id === d.id) return;
            else if (connectedNodeIds.has(nodeData.id)) $cf81072cf307ee25$export$2e2bcd8739ae039(this).classed("highlighted-ConnectedNode", true);
        });
    }
    getConnectedLinks(d) {
        return this._data.links.filter((link)=>link.source.id === d.id || link.target.id === d.id); // Array of connected links [{source, target}]
    }
    getConnectedNodes(connectedLinks) {
        return new Set(connectedLinks.flatMap((link)=>[
                link.source.id,
                link.target.id
            ])); // Set of ids of connected nodes [id]
    }
    addHandlerNodesLeaveEvents() {
        this._nodes.selectAll("circle").on("mouseleave pointerdown", (event)=>{
            if (event.type === "mouseleave") this.clearGraphState(this.currentNodeEl);
            if (event.type === "pointerdown") this.addHandlerClearHighlightMobile();
        });
    }
    addHandlerClearHighlightMobile() {
        this._containerEl.addEventListener("pointerdown", (event)=>{
            if (!event.target.closest(".nodes") && !event.target.closest(".tooltip")) this.clearGraphState(this.currentNodeEl);
        });
    }
    clearGraphState(currentNodeEl) {
        this.removeNodesHighlight();
        this.unhighlightTargetNode(currentNodeEl);
        this.removeTooltip();
    }
    removeNodesHighlight() {
        this._nodes.classed("overlayed", false);
        this._nodes.classed("highlighted-node ", false);
        this._nodes.classed("highlighted-ConnectedNode ", false);
        this._links.classed("overlayed", false);
        this._links.classed("highlighted-link", false);
    }
    // TODO: add guard clause so you can avoid issues on mobile
    addHandlerReloadSVG() {
        window.addEventListener("resize", ()=>{
            // if (window.innerHeight <= mobileScreenHeight) return;
            this.calculateContainerHeight();
            this.calculateContainerWidth();
            this._svg.attr("width", this.width).attr("height", this.height);
        });
    }
    //TOOLTIP
    createTooltipElement() {
        this.tooltip = $cf81072cf307ee25$export$2e2bcd8739ae039(this._container).append("div").attr("class", "tooltip").classed("hidden", true) // it has to be classed, not attr, or the last attr will overwrite the first
        .style("opacity", 0);
        return this.tooltip;
    }
    addHandlerRenderTooltip(event, d) {
        const targetNodeObject = this.identifyTargetNode(event);
        // Guard clause to avoid creating empty tooltip
        if (targetNodeObject.tldr.length === 0) return;
        if (this.isMobile()) {
            // For mobile: use a fixed overlay instead of JS-calculated positioning.
            this.tooltip.classed("overlay-mobile", true) // Apply your mobile overlay CSS class
            .classed("hidden", false) // Ensure hidden state is removed
            .style("position", "fixed") // Ensure fixed positioning
            // Remove any inline left/top styles (we rely solely on CSS for placement)
            .style("left", null).style("top", null).html(this.generateTooltipMarkup(targetNodeObject));
            this.addHandlerCloseTooltipMobile();
            // Transition the tooltip into view using your CSS transitions.
            this.tooltip.transition().duration(300).style("transform", "translateY(0)").style("opacity", 1);
        } else {
            // Desktop: calculate position based on the node's transformed coordinates.
            const currentTransform = $a3c1094a2e8782d7$export$2e2bcd8739ae039(this._svg.node()); // retrieves the current zoom transform state of the nodes (transform object)
            const transformedX = currentTransform.applyX(d.x); // returns new coordinates for the node
            const transformedY = currentTransform.applyY(d.y); // returns new coordinates for the node
            this.tooltip.classed("hidden", false).node().scrollTop = 0;
            this.tooltip.html(this.generateTooltipMarkup(targetNodeObject)).classed("tooltip", true).style("position", "absolute");
            this.updateTooltipPosition(transformedX, transformedY, event);
            this.tooltip.transition().duration(200).style("opacity", 0.9);
        }
    }
    addHandlerHoverTooltip() {
        this.tooltip.on("pointerenter", ()=>{
            clearTimeout(this.tooltipRemovalTimeout);
            this.isTooltipHovered = true; // not sure this logic works ???
            this.tooltip.style("opacity", 0.9);
        }).on("mouseleave", ()=>{
            this.isTooltipHovered = false;
            this.scheduleTooltipRemoval(this.isTooltipHovered);
        });
    }
    scheduleTooltipRemoval(isTooltipHovered) {
        clearTimeout(this.tooltipRemovalTimeout);
        // setTimeout serves to delay the hiding of the tooltip so the user has time to hover over it (debounce strategy)
        // tooltipRemovalTimeout is an id returned by setTimeout, which can be used to clear the timer
        this.tooltipRemovalTimeout = setTimeout(()=>{
            if (!isTooltipHovered) this.removeTooltip();
        }, 300);
    }
    removeTooltip() {
        this.tooltip.classed("hidden", true);
        this.tooltip.transition().duration(200).style("opacity", 0);
    }
    addHandlerCloseTooltipMobile() {
        this.tooltip.select(".close-overlay").on("click", ()=>{
            this.removeTooltip();
        });
    }
    renderTooltipMarkup(event) {
        return this.generateTooltipMarkup(this.identifyTargetNode(event));
    }
    // Maybe this can be avoided using the datum from d3 ???
    identifyTargetNode(event) {
        if (!event.target || !event.target.parentNode) return;
        //  DOM traversing - selecting the right element in the DOM
        const targetNodeParentEl = event.target.parentNode;
        // Identifying the text of the label and its guard clause
        const textLabel = targetNodeParentEl.querySelector("text");
        if (!textLabel) return;
        const nodeLabel = textLabel.textContent;
        //  Identifying target object between nodes
        const targetNodeObject = this._data.nodes.find((object)=>object.id === nodeLabel);
        if (!targetNodeObject) return;
        return targetNodeObject;
    }
    generateTooltipMarkup(targetNodeObject) {
        const tooltipContent = `
 <div class="tooltip-content">
 ${this.isMobile() ? '<button class="close-overlay" aria-label="Close">&times;</button>' : ""}
      <h5>Tl;Dr</h5>
      <ul>
      ${targetNodeObject.tldr.map((bullet)=>`<li class="tldr-text">${bullet}</li>`).join("")}
      </ul>
      <div class="tooltip-expand">
       ${`<a class="nav-link" id="tooltip-link" href="${targetNodeObject.url}" target="_blank">Expand ></a>`}
       </div>
    </div>`;
        return tooltipContent;
    }
    // checkReleaseDate(targetNodeObject) {
    //   const releaseDate = new Date(targetNodeObject.released);
    //   const currentDate = new Date();
    //   if (releaseDate >= currentDate) {
    //     return 'Coming soon';
    //   } else {
    //     return `<a class="nav-link" href="${targetNodeObject.url}" target="_blank">Read more →</a>`;
    //   }
    // }
    updateTooltipPosition(transformedX, transformedY, event) {
        // TransformedX and transformedY are relative to the SVG, not the viewport. NodeRect is the position of the node relative to the SVG. All the calculations need to be done relative to the viewport. The positioning has to be relative to the SVG.
        const nodeRect = event.target.getBoundingClientRect();
        const containerRect = this._containerEl.getBoundingClientRect();
        const tooltipNode = this.tooltip.node();
        const tooltipRect = tooltipNode.getBoundingClientRect();
        // Determine horizontal positioning
        let left;
        if (nodeRect.x + tooltipRect.width + 7 < containerRect.right) // Tooltip fits to the right of the node
        left = transformedX + 7;
        else if (nodeRect.x - tooltipRect.width - 7 >= containerRect.left) // Tooltip fits to the left of the node
        left = transformedX - tooltipRect.width - 7;
        else // Center the tooltip if it doesn't fit on either side
        left = containerRect.left + (containerRect.width - tooltipRect.width) / 2;
        // Determine vertical positioning
        let top = transformedY;
        // If tooltip would overflow bottom
        if (nodeRect.bottom + tooltipRect.height > containerRect.bottom) {
            // Calculate how much it overflows
            const overflow = nodeRect.bottom + tooltipRect.height - containerRect.bottom;
            // If there's room to move it up entirely, do so
            if (nodeRect.bottom - overflow >= containerRect.top) top -= overflow;
            else // Otherwise, center it vertically in the available space
            top = containerRect.top + (containerRect.height - tooltipRect.height) / 2;
        }
        // Apply the calculated position
        this.tooltip.style("left", `${left}px`).style("top", `${top}px`);
        // If the tooltip is taller than the container, adjust its height
        if (tooltipRect.height > containerRect.height) this.tooltip.style("max-height", `${containerRect.height - 10}px`);
    }
    // RESIZE BUTTON
    addHandlerRecenterGraph(getClonedData) {
        // Guard clause
        if (!this.btnResizeEl) {
            console.error("Resize button not initialized");
            return;
        }
        this.btnResizeEl.addEventListener("click", (e)=>{
            this.reRenderView(this, getClonedData);
        });
    }
    // RESIZE AFTER VIEWPORT CHANGE
    addHandlerResizeViewport(getClonedData) {
        window.addEventListener("resize", ()=>{
            if (!this.isMobile()) // On desktop: re-render the view.
            this.reRenderView(this, getClonedData);
            else {
                // On mobile: update the SVG dimensions only.
                this.calculateContainerHeight();
                this.calculateContainerWidth();
                this._svg.attr("width", this.width).attr("height", this.height);
            // Optionally, if you want to do nothing, you can simply return.
            }
        });
    }
    // SLUG RELATED FUNCTIONS
    // turn node ID into a slug node-id-xyz
    slugify(str) {
        return str.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, "") // remove special characters
        .replace(/\s+/g, "-"); // replace spaces with hyphens
    }
    // find the node by slug and return the selection and the datum
    _getNodeBySlug(slug) {
        const datum = this._data.nodes.find((node)=>this.slugify(node.id) === slug);
        if (!datum) return null;
        const sel = this._nodes.filter((d)=>d.id === datum.id);
        console.log("Selection:", sel);
        return sel.empty() ? null : {
            sel: sel,
            datum: datum
        };
    }
    highlightNodeBySlug(slug) {
        const found = this._getNodeBySlug(slug); // obj with sel and datum
        if (!found) return; // silent fall unknown slug
        const { sel: sel, datum: datum } = found;
        const gEl = sel.node();
        this.renderNodesHighlight(datum, gEl);
        this.currentNode = datum;
        this._parentElementId.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }
}



/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $10310cf078d13212$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $10310cf078d13212$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $10310cf078d13212$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $10310cf078d13212$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $10310cf078d13212$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $10310cf078d13212$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $10310cf078d13212$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $10310cf078d13212$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $10310cf078d13212$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $10310cf078d13212$export$803cd8101b6c182b) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $10310cf078d13212$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $10310cf078d13212$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $10310cf078d13212$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $10310cf078d13212$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $10310cf078d13212$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $10310cf078d13212$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $10310cf078d13212$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $10310cf078d13212$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $10310cf078d13212$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $10310cf078d13212$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $10310cf078d13212$export$ee05aea0aeecbad4)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $10310cf078d13212$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $10310cf078d13212$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $10310cf078d13212$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $10310cf078d13212$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $10310cf078d13212$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $10310cf078d13212$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $10310cf078d13212$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $10310cf078d13212$export$fef61f332f2c0afc)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $10310cf078d13212$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $10310cf078d13212$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $10310cf078d13212$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $10310cf078d13212$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $10310cf078d13212$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $10310cf078d13212$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $238ac70369f38756$var$hasWindow() {
    return typeof window !== "undefined";
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $238ac70369f38756$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $10310cf078d13212$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $10310cf078d13212$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(domElement)) return (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $10310cf078d13212$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $10310cf078d13212$export$a397704b5e280835)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if (!(0, $238ac70369f38756$export$78551043582a6a98)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $238ac70369f38756$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $238ac70369f38756$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $238ac70369f38756$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $238ac70369f38756$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $238ac70369f38756$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $238ac70369f38756$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $238ac70369f38756$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $238ac70369f38756$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== "body" || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll, true) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $10310cf078d13212$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $238ac70369f38756$export$3735103072e4a80)(body).direction === "rtl") x += (0, $10310cf078d13212$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    const html = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $238ac70369f38756$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $10310cf078d13212$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $238ac70369f38756$export$e495491855dc5418)(element));
    else if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $10310cf078d13212$export$ee05aea0aeecbad4)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(parentNode) || (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $238ac70369f38756$export$3735103072e4a80)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $238ac70369f38756$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $238ac70369f38756$export$45a5e7f76e0caa8d)(el) && (0, $238ac70369f38756$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $238ac70369f38756$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(currentNode) && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $238ac70369f38756$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $238ac70369f38756$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $238ac70369f38756$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $238ac70369f38756$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $238ac70369f38756$export$89e651af02346cd4)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $10310cf078d13212$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $10310cf078d13212$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $238ac70369f38756$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $238ac70369f38756$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $10310cf078d13212$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $238ac70369f38756$export$651544f548703224)(offsetParent) !== "body" || (0, $238ac70369f38756$export$989e911fa9af580a)(documentElement)) scroll = (0, $238ac70369f38756$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $10310cf078d13212$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "static";
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element) || (0, $238ac70369f38756$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $238ac70369f38756$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $238ac70369f38756$export$38b2d434cce3ea22)(element);
    if ((0, $238ac70369f38756$export$89e651af02346cd4)(element)) return win;
    if (!(0, $238ac70369f38756$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $238ac70369f38756$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $238ac70369f38756$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $238ac70369f38756$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $238ac70369f38756$export$71535ffaa902797f)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $238ac70369f38756$export$d1162fb0b6d4cd51)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $238ac70369f38756$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $238ac70369f38756$export$940d8225183e1404)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $238ac70369f38756$export$3735103072e4a80)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $238ac70369f38756$export$e495491855dc5418,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $238ac70369f38756$export$45a5e7f76e0caa8d,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $238ac70369f38756$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $10310cf078d13212$export$a3fe094919f356fd)(top);
        const insetRight = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $10310cf078d13212$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $10310cf078d13212$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $10310cf078d13212$export$8960430cfd85939f)(0, (0, $10310cf078d13212$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $238ac70369f38756$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $238ac70369f38756$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $973e4da43f2a375d$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $973e4da43f2a375d$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $973e4da43f2a375d$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $973e4da43f2a375d$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $973e4da43f2a375d$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $973e4da43f2a375d$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $973e4da43f2a375d$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $973e4da43f2a375d$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $973e4da43f2a375d$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $973e4da43f2a375d$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $973e4da43f2a375d$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};


class $e02bef6db2201a1a$var$HeroView extends (0, $4fd25a700b7c2bb6$export$2e2bcd8739ae039) {
    _parentElementId = document.querySelector(".graph-hero-container");
    _container = ".graph-container";
    _containerEl = document.querySelector(".graph-container");
    offsetWidth = 1;
    width = this._parentElementId.offsetWidth;
    height = this._parentElementId.offsetHeight;
    btnResizeEl = document.querySelector(".btn-resize");
    btnShareEl = document.querySelector(".btn-share");
    shareContainerEl = document.querySelector(".share-container");
    btnCopyLinkEl = document.querySelector(".share-button__copy");
    notificationCopiedLinkEl = document.querySelector(".notification");
    constructor(){
        super();
        this._addEventHandlers();
    }
    _addEventHandlers() {
        this._addHandlerShareModal();
        this._addHandlerCopyLink();
    }
    _addHandlerShareModal() {
        this.btnShareEl.addEventListener("click", (e)=>{
            e.stopPropagation();
            this.shareContainerEl.classList.toggle("hidden");
            document.addEventListener("click", (e)=>{
                if (!this.shareContainerEl.contains(e.target) && !this.btnShareEl.contains(e.target)) this.shareContainerEl.classList.add("hidden");
            });
            this._positionTooltip();
        });
    }
    _positionTooltip() {
        (0, $461947879dcdbcd4$export$48a53dcb22e581d0)(this.btnShareEl, this.shareContainerEl, {
            placement: "bottom",
            middleware: [
                (0, $461947879dcdbcd4$export$cc800923e997bb8)(7),
                (0, $461947879dcdbcd4$export$8a83211c878a3f1f)(),
                (0, $461947879dcdbcd4$export$fba63a578e423eb)()
            ]
        }).then(({ x: x, y: y })=>{
            Object.assign(this.shareContainerEl.style, {
                left: `${x}px`,
                top: `${y}px`
            });
        });
    }
    _addHandlerCopyLink() {
        this.btnCopyLinkEl.addEventListener("click", async ()=>{
            try {
                await navigator.clipboard.writeText(window.location.href);
                // Notification for copied link
                this.notificationCopiedLinkEl.classList.remove("hidden");
                setTimeout(()=>{
                    this.notificationCopiedLinkEl.classList.add("hidden");
                }, 2000);
                // Close the tooltip
                this.shareContainerEl.classList.toggle("hidden");
            } catch (err) {
                console.error("Failed to copy:", err);
            }
        });
    }
}
var $e02bef6db2201a1a$export$2e2bcd8739ae039 = new $e02bef6db2201a1a$var$HeroView();


class $7d57ce3a3e32724d$var$ModalView extends (0, $4fd25a700b7c2bb6$export$2e2bcd8739ae039) {
    _parentElementId = document.querySelector(".graph-modal-container");
    width;
    height;
    _container = ".graph-modal-svg";
    _containerEl = document.querySelector(".graph-modal-svg");
    offsetWidth = 1;
    _icon = document.querySelector(".graph-icon");
    _modal = document.querySelector(".graph-modal");
    _modalBtn = document.querySelector(".graph-modal-btn--resize");
    // add event handler
    addHandlerRenderModal(data) {
        this._icon.addEventListener("click", ()=>{
            console.log("START");
            this._modal.classList.remove("hidden");
            this.calculateContainerWidth();
            this.calculateContainerHeight();
            // ternary operator, either render the chart or refresh the chart
            this._parentElementId.querySelector("svg") !== null ? this.renderSimulation() : this.renderView(data);
        });
    }
    addHandlerCloseModal(getClonedData) {
        this._modal.addEventListener("click", (e)=>{
            if (e.target !== this._modal) return; // guard clause to make sure that modal closes only on the transparent overlay
            this.toggleHidden(this._modal);
            // Resetting the view for the hero-container
            this.reRenderView((0, $e02bef6db2201a1a$export$2e2bcd8739ae039), getClonedData);
        });
    }
}
var $7d57ce3a3e32724d$export$2e2bcd8739ae039 = new $7d57ce3a3e32724d$var$ModalView();



// Function to clone the data, added here because model is automatically generated
const $225c66d4f477ca9c$var$cloneData = function(data) {
    return JSON.parse(JSON.stringify(data));
};
const $225c66d4f477ca9c$var$getNodeSlugFromURL = ()=>{
    const params = new URLSearchParams(window.location.search);
    const slug = params.get("node");
    return slug ? decodeURIComponent(slug) : null;
};
const $225c66d4f477ca9c$var$init = function() {
    const nodeSlug = $225c66d4f477ca9c$var$getNodeSlugFromURL();
    (0, $e02bef6db2201a1a$export$2e2bcd8739ae039).renderView($225c66d4f477ca9c$var$cloneData($cdbf8f036183e294$export$4051a07651545597));
    (0, $e02bef6db2201a1a$export$2e2bcd8739ae039).addHandlerRecenterGraph(()=>$225c66d4f477ca9c$var$cloneData($cdbf8f036183e294$export$4051a07651545597));
    (0, $e02bef6db2201a1a$export$2e2bcd8739ae039).addHandlerResizeViewport(()=>$225c66d4f477ca9c$var$cloneData($cdbf8f036183e294$export$4051a07651545597));
    // modalView.addHandlerRenderModal(cloneData(model.data));
    // modalView.addHandlerCloseModal(() => cloneData(model.data));
    if (nodeSlug) (0, $e02bef6db2201a1a$export$2e2bcd8739ae039).highlightNodeBySlug(nodeSlug);
};
$225c66d4f477ca9c$var$init();


//# sourceMappingURL=index.31a8c2e5.js.map
